/* ════════════════════════════════════════════════════════════════════════
   EPIC LABS® · Cart Drawer Premium · Client Engine
   ═════════════════════════════════════════════════════════════════════════
   Núcleo reactivo del drawer:
   · Sync con /cart.js + intercepción de fetch/XHR para AJAX cart events
   · Render items dinámico + qty stepper + swipe/remove + undo toast
   · Free-shipping bar progresiva + confetti al desbloquear
   · Tier discount visualizer (1/2/3/4 items)
   · Upsell carrusel desde /recommendations/products.json
   · Same-day dispatch countdown (geo-promise integrado)
   · Haptic feedback (Vibration API)
   · Convivencia con Kaching: solo toma control si:
       a) ?epic_drawer=preview en URL  → preview mode
       b) window.EPIC_USE_NATIVE_CART === true  → control total
   ═════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.__epicCartDrawerInit) return;
  window.__epicCartDrawerInit = true;

  /* ──────────────────────────────────────────────────────────────────
     1. CONFIG + ESTADO INICIAL
     ────────────────────────────────────────────────────────────────── */
  var ROOT = document.getElementById('epic-cart-drawer');
  if (!ROOT) return;

  var THR   = parseInt(ROOT.getAttribute('data-thr'), 10) || 149900;
  var FEE   = parseInt(ROOT.getAttribute('data-fee'), 10) || 9900;
  var CART_URL = ROOT.getAttribute('data-cart-url') || '/cart';

  var URL_PARAMS = (function () {
    try { return new URLSearchParams(window.location.search); } catch (e) { return null; }
  })();
  var PREVIEW = URL_PARAMS && URL_PARAMS.get('epic_drawer') === 'preview';
  /* 2026-05-27 · Kaching Cart embed se apagó del theme editor.
     EPIC Drawer toma control universal de #cart-icon-bubble y cualquier link al /cart.
     Si algún día reactivas Kaching, setea window.EPIC_USE_NATIVE_CART = false antes de epic-cart-drawer.js o quita este bool. */
  var TAKE_OVER = true;

  /* Barra de descuento por VOLUMEN (reactivada 2026-06).
     Shopify tiene 3 descuentos AUTOMÁTICOS activos por CANTIDAD TOTAL de mercancía
     (cualquier producto, incluido mismo SKU): 2 pzas 5%, 3 pzas 8%, 4+ pzas 10%.
     Esta barra es INFORMATIVA/persuasiva: muestra el siguiente escalón y el estado
     logrado. El descuento real lo aplica Shopify en checkout; aquí NO se inyectan
     códigos. Cuenta vía merchItemCount (excluye protección de envío / servicios). */
  var VOLUME_TIERS = [
    { qty: 2, pct: 5 },
    { qty: 3, pct: 8 },
    { qty: 4, pct: 10 }
  ];

  /* PRODUCTOS INDIVIDUALES sujetos al descuento por volumen (los 4 sueltos).
     2026-06: los 3 descuentos automáticos de Shopify aplican SOLO a estos 4 SKUs,
     NO a protocolos/paquetes (esos ya vienen pre-descontados). La barra de volumen
     debe contar ÚNICAMENTE unidades de estos productos. Detección robusta por
     product_id O handle (fuente de verdad doble: si Shopify cambia uno, queda el otro). */
  var VOLUME_PRODUCT_IDS = [9958593921335, 9958593986871, 9958594019639, 9958815531319];
  var VOLUME_PRODUCT_HANDLES = [
    'creanova-creatina-monohidratada-vitamina-b6-alta-absorcion',
    'core-x-formula-rendimiento-elite',
    'bio-mag-magnesio-glicinato-recuperacion-rendimiento',
    'pump-x-preentreno-sin-estimulantes-bombeo-enfoque'
  ];
  function isVolumeProduct(item) {
    if (!item) return false;
    if (item.product_id && VOLUME_PRODUCT_IDS.indexOf(item.product_id) !== -1) return true;
    var h = item.handle || (item.url && item.url.split('/products/')[1] && item.url.split('/products/')[1].split('?')[0]) || '';
    return VOLUME_PRODUCT_HANDLES.indexOf(h) !== -1;
  }
  /* Cuenta SOLO unidades de los 4 productos individuales (lo que de verdad
     cuenta para el descuento por volumen). Protocolos/paquetes NO suman. */
  function volumeUnitCount(cart) {
    return ((cart && cart.items) || []).reduce(function (n, it) {
      return n + (isVolumeProduct(it) ? (it.quantity || 0) : 0);
    }, 0);
  }

  /* ── PROTOCOLOS / PAQUETES ──────────────────────────────────────────
     Los paquetes ya traen su descuento HORNEADO en el precio. NO suman para
     el descuento por volumen (esa escalera es para apilar productos sueltos)
     y NO deben recibir el nudge "Suma 1 producto y ahorra X%".
     Detección por HANDLE: contiene "protocolo" o "paquete".
     Escalera de precio (de menor a mayor) para ofrecer SUBIR de tier por VALOR
     (no por envío, no por volumen). El handle Elite es terminal: no hay escalón. */
  var ELITE_HANDLE = 'paquete-elite-epic-performance';
  /* tier: orden ascendente. Cada entrada = qué handles caen en ese nivel.
     `next` = handle del paquete inmediato superior a ofrecer (null = terminal). */
  var PROTOCOL_LADDER = [
    { match: 'protocolo-mitocondria', price: 1149, name: 'Protocolo Mitocondria', next: 'paquete-elite-epic-performance', nextName: 'Protocolo Elite' },
    { match: 'products-protocolo-base', price: 1499, name: 'Protocolo Base', next: 'paquete-elite-epic-performance', nextName: 'Protocolo Elite' },
    { match: 'protocolo-base', price: 1499, name: 'Protocolo Base', next: 'paquete-elite-epic-performance', nextName: 'Protocolo Elite' },
    { match: 'protocolo-peak', price: 1499, name: 'Protocolo Peak', next: 'paquete-elite-epic-performance', nextName: 'Protocolo Elite' },
    { match: 'protocolo-alpha', price: 1499, name: 'Protocolo Alpha', next: 'paquete-elite-epic-performance', nextName: 'Protocolo Elite' },
    { match: 'protocolo-neuro', price: 1999, name: 'Protocolo Neuro', next: 'paquete-elite-epic-performance', nextName: 'Protocolo Elite' }
  ];
  /* handle de una línea (handle nativo o parseado de la URL) */
  function itemHandle(it) {
    if (!it) return '';
    return it.handle || (it.url && it.url.split('/products/')[1] && it.url.split('/products/')[1].split('?')[0]) || '';
  }
  /* ¿Es un paquete/protocolo? handle contiene "protocolo" o "paquete". */
  function isPackage(item) {
    var h = (itemHandle(item) || '').toLowerCase();
    return h.indexOf('protocolo') !== -1 || h.indexOf('paquete') !== -1;
  }
  /* ¿Hay algún paquete/protocolo en el carrito? */
  function cartHasPackage(cart) {
    return ((cart && cart.items) || []).some(isPackage);
  }
  /* ¿El Elite ya está en el carrito? (estado terminal, no hay a dónde subir) */
  function cartHasElite(cart) {
    return ((cart && cart.items) || []).some(function (it) {
      return (itemHandle(it) || '').toLowerCase().indexOf(ELITE_HANDLE) !== -1;
    });
  }
  /* Devuelve el escalón a ofrecer: el paquete NO Elite de MENOR tier presente
     en el carrito (para empujar hacia arriba desde donde está). null si no hay
     paquete no-Elite, o si el Elite ya está (terminal). */
  function escalationTarget(cart) {
    if (!cart || !cart.items) return null;
    if (cartHasElite(cart)) return null;
    for (var t = 0; t < PROTOCOL_LADDER.length; t++) {
      var tier = PROTOCOL_LADDER[t];
      var present = cart.items.some(function (it) {
        return (itemHandle(it) || '').toLowerCase().indexOf(tier.match) !== -1;
      });
      if (present && tier.next) return tier;
    }
    return null;
  }

  /* Cache de últimos datos del carrito y queue de operaciones */
  var STATE = {
    cart: null,
    busy: false,
    removedQueue: [],         /* cola de removidos para undo · remociones seguidas se AGREGAN (un solo toast) */
    undoTimer: null,
    countdownTimer: null,
    shakerLoaded: false,
    shakerVariantId: null,
    shakerImage: null,
    /* Cross-sell inteligente · recomendación REAL de Shopify según lo que lleva el carrito */
    crossSell: null,          /* {variant_id, product_id, title, image, price, handle} */
    _crossSellSeed: null,     /* product_id semilla ya consultado (evita refetch) */
    _crossSellBusy: false
  };

  /* ──────────────────────────────────────────────────────────────────
     2. UTILS
     ────────────────────────────────────────────────────────────────── */
  function $(sel, scope) { return (scope || ROOT).querySelector(sel); }
  function $$(sel, scope) { return Array.from((scope || ROOT).querySelectorAll(sel)); }
  function money(cents) {
    var n = Math.max(0, Math.round(cents / 100));
    try { return '$' + n.toLocaleString('es-MX'); } catch (e) { return '$' + n; }
  }
  function vibrate(ms) {
    try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) {}
  }
  /* fetch NATIVO capturado al cargar el drawer — ANTES de que bindAjaxObserver
     envuelva window.fetch. Las operaciones internas del drawer (qty, remove,
     protección, suscripción, shaker) usan ESTE fetch para NO re-disparar el
     interceptor → sin cascada de re-renders ("vuelve a cargar todo").
     El interceptor solo debe reaccionar a ATC EXTERNOS (product-form del tema). */
  var _nativeFetch = (typeof window.fetch === 'function') ? window.fetch.bind(window) : null;
  function fetchJSON(url, opts) {
    var f = _nativeFetch || window.fetch;
    return f(url, Object.assign({ credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }, opts || {}))
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function setBusy(on) {
    STATE.busy = !!on;
    ROOT.classList.toggle('is-busy', !!on);
  }

  /* ── Protección de envío · helpers ──
     Es un line item (Shopify necesita la línea para cobrar) PERO en el drawer NUNCA
     se muestra como producto: se controla SOLO con el toggle. La detectamos para
     filtrarla de la lista y excluirla del total de mercancía. */
  function isProtection(item) {
    if (!item) return false;
    return item.handle === 'proteccion-de-envio-epic' || item.product_type === 'Servicio';
  }
  function protectionLineOf(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) { if (isProtection(cart.items[i])) return cart.items[i]; }
    return null;
  }
  /* Total de MERCANCÍA = total del carrito menos la protección (no es mercancía).
     Se usa para la barra de envío y los regalos para que la protección no infle umbrales. */
  function merchTotal(cart) {
    var t = (cart && cart.total_price) || 0;
    var p = protectionLineOf(cart);
    return Math.max(0, t - (p ? p.final_line_price : 0));
  }

  /* ── Shaker promo · helpers ──
     El código SHAKERBB129 aplica $129 al pagar; en el carrito la línea está a precio
     lista ($299). Calculamos el ahorro para MOSTRAR el precio real ($129) en la línea
     y reflejar el total que de verdad pagará el cliente (sin tocar precios en vivo). */
  var SHAKER_PROMO_CENTS = 12900;
  function shakerLineOf(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) { if (/shaker/i.test(cart.items[i].product_title || '')) return cart.items[i]; }
    return null;
  }
  function shakerSaving(cart) {
    var s = shakerLineOf(cart);
    /* FIX audit #3/#2 · el promo $129 (código SHAKERBB129) está pensado para 1 Shaker.
       Con qty≥2 no podemos garantizar el descuento por unidad → no fingimos ahorro.
       Así el total mostrado nunca queda por DEBAJO de lo que de verdad se cobra. */
    if (!s || (s.quantity || 1) !== 1) return 0;
    return Math.max(0, (s.final_line_price || 0) - SHAKER_PROMO_CENTS);
  }
  /* Ahorro total por suscripción (compare_at del selling plan vs precio con plan).
     Shopify NO lo cuenta en original_line_price, así que lo calculamos aparte. */
  function subscriptionSavings(cart) {
    var s = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.selling_plan_allocation && it.selling_plan_allocation.compare_at_price) {
        var o = it.selling_plan_allocation.compare_at_price * (it.quantity || 1);
        if (o > (it.final_line_price || 0)) s += o - it.final_line_price;
      }
    });
    return s;
  }
  /* Precio "antes" de una línea (para tachar). Fuentes de descuento:
     · Suscripción → compare_at_price del selling plan (precio sin suscripción)
     · Bundle / descuento de línea → original_line_price
     Devuelve 0 si no hay ahorro. */
  function lineOriginalPrice(item) {
    var final = item.final_line_price || 0;
    if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
      var cmp = item.selling_plan_allocation.compare_at_price * (item.quantity || 1);
      if (cmp > final) return cmp;
    }
    if (item.original_line_price && item.original_line_price > final) return item.original_line_price;
    return 0;
  }
  /* Bloque de precio premium: precio tachado + precio final + "Ahorras $X" sutil.
     Pedido del usuario: que sepan que están ahorrando, sin gritarlo. Sin middot ni %. */
  function priceBlockHtml(original, now) {
    var save = original - now;
    var saveLbl = save > 0
      ? '<span class="ecd__item-save">Ahorras ' + money(save) + '</span>'
      : '';
    return '<s class="ecd__item-was">' + money(original) + '</s>' +
           '<b class="ecd__item-now ecd__item-now--save">' + money(now) + '</b>' + saveLbl;
  }
  /* HTML del precio de una línea. Caso especial Shaker: $129 (tachado $299) por el
     código SHAKERBB129. Para suscripción/bundle usa lineOriginalPrice. */
  function itemPriceHtml(item) {
    if (/shaker/i.test(item.product_title || '') && (item.quantity || 1) === 1) {
      /* FIX #3 · solo mostramos $129 con 1 unidad (el promo es por 1). qty≥2 → precio real. */
      if ((item.final_line_price || 0) > SHAKER_PROMO_CENTS) return priceBlockHtml(item.final_line_price, SHAKER_PROMO_CENTS);
    }
    var orig = lineOriginalPrice(item);
    if (orig > 0) return priceBlockHtml(orig, item.final_line_price);
    return '<b class="ecd__item-now">' + money(item.final_line_price) + '</b>';
  }

  /* ──────────────────────────────────────────────────────────────────
     3. OPEN / CLOSE DRAWER
     · iOS-safe body scroll lock: position:fixed + restore scroll exacto al cerrar
     · Apple Store iOS pattern: panel respeta altura del header (no overlay total)
     ────────────────────────────────────────────────────────────────── */
  STATE.savedScrollY = 0;

  /* Config del Shaker downsell · MISMO patrón que bundle/hotsale builders.
     Código SHAKERBB129 ya creado en Admin (descuento $170 off variant Shaker).
     Al checkout: cadena /discount/SHAKERBB129?redirect=/checkout y Shopify aplica.
     Si el código se renombra, cambia aquí. */
  var SHAKER_DISCOUNT_CODE = 'SHAKERBB129';
  var SHAKER_PROMO_PRICE = '$129';

  function getHeaderHeight() {
    /* Detecta el header del tema (sticky-header / .section-header / .header-wrapper) */
    var h = document.querySelector('sticky-header, .section-header, .header-wrapper, header.header, #shopify-section-sections--header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    /* Si el header está sticky/fixed, su top puede ser 0 y bottom = altura */
    return Math.max(0, Math.round(r.bottom));
  }

  /* Colapso fluido de una fila al quitarla: fija la altura → reflow → anímala a 0
     (+ padding y margin-bottom negativo para comer el gap:10px del contenedor flex)
     para que las filas de abajo SUBAN suave en vez de saltar. Idempotente. */
  function collapseRow(el) {
    if (!el || el.classList.contains('is-removing')) return;
    var h = el.offsetHeight;
    el.style.height = h + 'px';
    void el.offsetHeight; /* reflow con altura explícita, antes de transicionar */
    el.classList.add('is-removing');
    requestAnimationFrame(function () {
      el.style.height = '0px';
      el.style.paddingTop = '0px';
      el.style.paddingBottom = '0px';
      el.style.marginBottom = '-10px';
    });
  }

  function open() {
    if (ROOT.classList.contains('is-open')) return;
    /* Guarda scroll para restore al cerrar (iOS safe) */
    STATE.savedScrollY = window.scrollY || window.pageYOffset || 0;
    /* En web el drawer va de top:0 (igual al carrito nativo del tema), cubriendo el header.
       Limpia cualquier offset inline previo por si quedó de una versión anterior. */
    var panel = $('.ecd__panel');
    if (panel) panel.style.top = '';
    /* Aplica lock-scroll antes de mostrar para que el viewport no salte */
    document.body.style.top = '-' + STATE.savedScrollY + 'px';
    document.body.classList.add('ecd-open');

    ROOT.classList.add('is-open');
    ROOT.setAttribute('aria-hidden', 'false');
    refresh().then(function () { renderOffer(STATE.cart); startCountdown(); });
    vibrate(10);
  }
  function close() {
    if (!ROOT.classList.contains('is-open')) return;
    ROOT.classList.remove('is-open');
    ROOT.setAttribute('aria-hidden', 'true');
    /* Restore scroll position exactly */
    document.body.classList.remove('ecd-open');
    document.body.style.top = '';
    if (STATE.savedScrollY) {
      window.scrollTo(0, STATE.savedScrollY);
      STATE.savedScrollY = 0;
    }
    stopCountdown();
    hideToast();
    vibrate(8);
  }
  window.EPIC_CART_OPEN = open;
  window.EPIC_CART_CLOSE = close;

  /* ──────────────────────────────────────────────────────────────────
     4. INTERCEPCIÓN DEL CART ICON BUBBLE
     ────────────────────────────────────────────────────────────────── */
  function bindCartIcon() {
    /* Capture-phase para ganar el click ANTES que cualquier residuo del Kaching script
       que pueda haber quedado en cache, y antes que la nav nativa al /cart. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('#cart-icon-bubble, [href$="/cart"], [href="/cart"], [data-epic-cart-open]');
      if (!a) return;
      var href = (a.getAttribute('href') || '').toLowerCase();
      /* Solo interceptar links directos al carrito (no /cart/add ni subrutas) */
      if (href && href !== '/cart' && href !== '/cart?' && href.indexOf('/cart#') !== 0 && href.indexOf('/cart?') !== 0 && href.indexOf('#cart') !== 0) {
        if (a.id !== 'cart-icon-bubble' && !a.hasAttribute('data-epic-cart-open')) return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open();
    }, true);

    /* Atajo de URL para preview rápido (legado, ya no requerido pero conservado) */
    if (PREVIEW) setTimeout(open, 300);
  }

  /* ──────────────────────────────────────────────────────────────────
     5. CART REFRESH · debounced + dedup
     · Coalesce múltiples eventos en rápida sucesión (cart:added,
       cart:refresh, /cart/add.js, etc.) en una sola llamada a /cart.js
     · Skip render si nada cambió (compara fingerprint)
     ────────────────────────────────────────────────────────────────── */
  var _refreshTimer = null;
  var _refreshPromise = null;
  var _refreshResolve = null;

  function cartFingerprint(c) {
    if (!c) return '';
    return c.item_count + '|' + c.total_price + '|' + (c.items || []).map(function (i) {
      return i.key + ':' + i.quantity + ':' + i.final_line_price + ':' + ((i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) ? i.selling_plan_allocation.selling_plan.id : '0');
    }).join(';');
  }

  function refresh() {
    if (!_refreshPromise) {
      _refreshPromise = new Promise(function (resolve) { _refreshResolve = resolve; });
    }
    clearTimeout(_refreshTimer);
    _refreshTimer = setTimeout(function () {
      fetchJSON('/cart.js').then(function (cart) {
        var oldFp = cartFingerprint(STATE.cart);
        var newFp = cartFingerprint(cart);
        STATE.cart = cart;
        /* Render si: (a) NUNCA se ha renderizado por JS (el SSR puede estar desincronizado,
           p.ej. la barra hardcodeada a "$1,799"), o (b) el carrito cambió.
           Esto arregla el desync: abrir el drawer SIEMPRE sincroniza la barra con el carrito real. */
        if (!STATE.hasRendered || oldFp !== newFp) {
          STATE.hasRendered = true;
          render(cart);
        } else {
          var _mc = merchItemCount(cart);
          var countEl = $('[data-ecd-count]');
          if (countEl) countEl.textContent = _mc;
          syncCartBubbles(_mc);
        }
        var r = _refreshResolve;
        _refreshPromise = null;
        _refreshResolve = null;
        if (r) r(cart);
      }).catch(function (err) {
        console.warn('[EPIC] refresh failed', err);
        var r = _refreshResolve;
        _refreshPromise = null;
        _refreshResolve = null;
        if (r) r(null);
      });
    }, 80);
    return _refreshPromise;
  }

  /* Cuenta SOLO mercancía (sin protección de envío ni "Servicio"), igual que el Dock:
     el badge del carrito refleja productos reales, NO el add-on de protección. */
  function merchItemCount(cart) {
    return ((cart && cart.items) || []).reduce(function (n, it) { return n + (isProtection(it) ? 0 : (it.quantity || 0)); }, 0);
  }

  /* Sincroniza el número del carrito en TODOS lados: el badge del drawer ya se
     actualiza, pero el bubble del header (#cart-icon-bubble) y el del carrito
     flotante NO se tocaban al borrar via AJAX → quedaban con el número viejo
     ("parece que aún hay productos"). Esto los pone al día (y los vacía a 0). */
  function syncCartBubbles(count) {
    try {
      count = count || 0;
      var txt = count < 100 ? String(count) : '99+';
      /* Header Dawn (#cart-icon-bubble): crea / actualiza / quita el bubble */
      var host = document.querySelector('#cart-icon-bubble');
      if (host) {
        var hw = host.querySelector('.cart-count-bubble');
        if (count > 0) {
          if (!hw) { hw = document.createElement('div'); hw.className = 'cart-count-bubble'; hw.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>'; host.appendChild(hw); }
          var hn = hw.querySelector('[aria-hidden="true"]');
          if (hn) hn.textContent = txt; else hw.insertAdjacentHTML('afterbegin', '<span aria-hidden="true">' + txt + '</span>');
        } else if (hw) { hw.remove(); }
      }
      /* Carrito flotante (y cualquier otro .cart-count-bubble fuera del header).
         Fuente ÚNICA: aquí actualizamos número, visibilidad Y el rebote (antes lo
         duplicaba un MutationObserver en float-cart.liquid → doble bump). */
      document.querySelectorAll('.float-cart .cart-count-bubble').forEach(function (b) {
        var n = b.querySelector('[aria-hidden="true"]');
        var prev = n ? n.textContent : '';
        if (count > 0) { if (n) n.textContent = txt; b.style.display = ''; }
        else { if (n) n.textContent = '0'; b.style.display = 'none'; }
        var fc = b.closest('.float-cart');
        if (fc && count > 0 && prev !== txt && prev !== '') {
          fc.classList.remove('is-bump'); void fc.offsetWidth; fc.classList.add('is-bump');
          setTimeout(function () { fc.classList.remove('is-bump'); }, 600);
        }
      });
      document.querySelectorAll('.float-cart').forEach(function (fc) { fc.classList.toggle('has-items', count > 0); });
    } catch (e) {}
  }

  /* Baja el contador AL INSTANTE al quitar una línea (antes de que responda la red),
     restando la cantidad de esa línea al total actual. */
  function optimisticCount(key) {
    try {
      var ci = ((STATE.cart && STATE.cart.items) || []).filter(function (it) { return it.key === key; })[0];
      var rq = (ci && !isProtection(ci)) ? (ci.quantity || 1) : 0;
      syncCartBubbles(Math.max(0, merchItemCount(STATE.cart) - rq));
    } catch (e) {}
  }

  function render(cart) {
    /* count badge · SOLO mercancía (sin protección), consistente con el Dock */
    var _mc = merchItemCount(cart);
    var countEl = $('[data-ecd-count]');
    if (countEl) countEl.textContent = _mc;
    syncCartBubbles(_mc);

    /* empty vs items */
    var emptyEl = $('[data-ecd-empty]');
    var itemsEl = $('[data-ecd-items]');
    var footerEl = $('[data-ecd-footer]');
    var addonEl = $('[data-ecd-addon]');

    /* FIX audit #1 · "vacío" = sin MERCANCÍA. La protección es un line item oculto;
       un carrito que quedó SOLO con la protección NO debe mostrar footer ni "Ir a pagar $69". */
    var merchCount = (cart.items || []).filter(function (it) { return !isProtection(it); }).length;
    if (merchCount === 0) {
      if (emptyEl) emptyEl.hidden = false;
      if (itemsEl) itemsEl.hidden = true;
      if (footerEl) footerEl.hidden = true;
      if (addonEl) addonEl.hidden = true;
      /* Limpia la protección huérfana (no se puede cobrar protección sin productos) */
      if (cart.item_count > 0 && !STATE._cleaningProtect) {
        var orphan = protectionLineOf(cart);
        if (orphan) {
          STATE._cleaningProtect = true;
          fetchJSON('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: orphan.key, quantity: 0 }) })
            .then(function () { STATE._cleaningProtect = false; refresh(); })
            .catch(function () { STATE._cleaningProtect = false; });
        }
      }
    } else {
      if (emptyEl) emptyEl.hidden = true;
      if (itemsEl) itemsEl.hidden = false;
      if (footerEl) footerEl.hidden = false;
      if (addonEl) addonEl.hidden = false;
      renderItems(cart);
    }

    /* shipping bar */
    renderShippingBar(cart);

    /* barra de descuento por volumen (informativa · descuento automático Shopify) */
    renderVolumeBar(cart);

    /* totals */
    renderTotals(cart);

    /* smart offer engine — un solo card adaptativo */
    renderOffer(cart);

    /* shipping protection toggle */
    renderProtection(cart);
    syncProtectionPlan(cart); /* protección recurrente si el carrito es de suscripción */
  }

  /* ──────────────────────────────────────────────────────────────────
     DIFF RENDER · bulletproof v8
     Antes: ul.innerHTML = html destruía y recreaba TODAS las imágenes en cada
     refresh — el browser re-fetcheaba los IMG aunque fueran idénticos → flicker.
     Ahora: keyed reconciliation tipo React/Vue. Solo añade/quita/actualiza
     lo que cambió. Las imágenes EXISTENTES nunca se tocan → cero flicker.
     ────────────────────────────────────────────────────────────────── */
  function buildItemElement(item) {
    var li = document.createElement('li');
    li.className = 'ecd__item';
    li.setAttribute('data-ecd-item', '');
    li.setAttribute('data-key', item.key);
    /* Hide the shipping protection item — el cliente lo controla con su toggle dedicado */
    if (item.handle === 'proteccion-de-envio-epic' || item.product_type === 'Servicio') {
      li.classList.add('is-hidden-line');
    }
    var img = item.image ? '<img src="' + img2x(item.image, 200) + '" alt="" width="64" height="64" loading="lazy" decoding="async">' : '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="ecd__item-variant">' + escapeHtml(item.variant_title) + '</span>' : '';
    var sub = item.selling_plan_allocation ? '<span class="ecd__item-sub">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</span>' : '';
    var prv = (item.handle === 'pump-x-preentreno-sin-estimulantes-bombeo-enfoque') ? '<span class="ecd__item-prv">Lote limitado: 50 piezas, se envía de inmediato</span>' : '';
    var priceHtml = itemPriceHtml(item);
    li.innerHTML =
      '<a href="' + item.url + '" class="ecd__item-img" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="ecd__item-info">' +
        '<a href="' + item.url + '" class="ecd__item-title">' + escapeHtml(item.product_title) + '</a>' +
        variant + sub + prv +
        '<div class="ecd__item-row">' +
          '<div class="ecd__qty" data-ecd-qty data-key="' + item.key + '">' +
            '<button type="button" class="ecd__qty-btn" data-ecd-qty-dec aria-label="Quitar uno"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
            '<span class="ecd__qty-n" data-ecd-qty-n>' + item.quantity + '</span>' +
            '<button type="button" class="ecd__qty-btn" data-ecd-qty-inc aria-label="Agregar uno"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
          '</div>' +
          '<div class="ecd__item-price">' + priceHtml + '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="ecd__item-remove" data-ecd-remove data-key="' + item.key + '" aria-label="Quitar producto"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg></button>';
    return li;
  }

  function updateItemElement(li, item) {
    /* Actualiza qty, precio, suscripción IN PLACE. No toca la imagen. */
    var qtyEl = li.querySelector('[data-ecd-qty-n]');
    if (qtyEl && qtyEl.textContent !== String(item.quantity)) qtyEl.textContent = item.quantity;

    var priceWrap = li.querySelector('.ecd__item-price');
    if (priceWrap) {
      var newPriceHtml = itemPriceHtml(item);
      /* Solo actualizar si el HTML del precio cambió */
      if (priceWrap.innerHTML !== newPriceHtml) priceWrap.innerHTML = newPriceHtml;
    }

    /* Subscripción badge (se quita o agrega según selling_plan_allocation) */
    var info = li.querySelector('.ecd__item-info');
    var existingSub = info && info.querySelector('.ecd__item-sub');
    var subName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null;
    if (subName) {
      if (existingSub) {
        if (existingSub.textContent !== subName) existingSub.textContent = subName;
      } else if (info) {
        var span = document.createElement('span');
        span.className = 'ecd__item-sub';
        span.textContent = subName;
        var firstRow = info.querySelector('.ecd__item-row');
        info.insertBefore(span, firstRow);
      }
    } else if (existingSub) {
      existingSub.remove();
    }
  }

  function renderItems(cart) {
    var ul = $('[data-ecd-items]');
    if (!ul) return;

    /* La protección de envío NUNCA aparece como línea (se controla SOLO con el toggle).
       La filtramos; cualquier nodo de protección heredado del SSR se elimina al instante. */
    var visibleItems = cart.items.filter(function (it) { return !isProtection(it); });

    /* Mapa de elementos existentes por key */
    var existing = {};
    Array.prototype.forEach.call(ul.children, function (li) {
      var k = li.getAttribute('data-key');
      if (k) existing[k] = li;
    });

    var newKeys = {};
    visibleItems.forEach(function (it) { newKeys[it.key] = true; });

    /* 1. Eliminar items que ya no están (incluye protección heredada del SSR) */
    Object.keys(existing).forEach(function (k) {
      if (!newKeys[k]) {
        var li = existing[k];
        /* Protección heredada del SSR → quitar al instante (sin animación de salida) */
        if (li.getAttribute('data-ecd-protect-line') === '1') { if (li.parentNode) li.remove(); return; }
        /* Ya colapsado por el botón de borrar (is-removing) → ya es invisible, quítalo al instante. */
        if (li.classList.contains('is-removing')) { if (li.parentNode) li.remove(); return; }
        /* Removido por una vía externa (no por el botón) → colapsa con fluidez. */
        collapseRow(li);
        setTimeout(function () { if (li.parentNode) li.remove(); }, 360);
      }
    });

    /* 2. Reordenar / agregar / actualizar */
    visibleItems.forEach(function (item, idx) {
      var li = existing[item.key];
      if (li) {
        /* Update in place — no toca img */
        updateItemElement(li, item);
        /* Reposiciona si está en orden incorrecto */
        if (ul.children[idx] !== li) {
          ul.insertBefore(li, ul.children[idx] || null);
        }
      } else {
        /* Nuevo item — append en posición correcta */
        var newLi = buildItemElement(item);
        var ref = ul.children[idx];
        if (ref) ul.insertBefore(newLi, ref);
        else ul.appendChild(newLi);
      }
    });
  }

  /* Lee los tiers de regalo del SSR (monto en pesos → centavos, + nombre).
     Los regalos NO son productos (no contaminan métricas); solo nombre + umbral. */
  function getGiftTiers() {
    var bar = $('[data-ecd-bar]');
    if (!bar) return [];
    var out = [];
    [['data-tier2-amt', 'data-tier2-label'], ['data-tier3-amt', 'data-tier3-label']].forEach(function (pair) {
      var amt = parseInt(bar.getAttribute(pair[0]), 10);
      var label = (bar.getAttribute(pair[1]) || '').trim();
      if (amt > 0 && label) out.push({ amt: amt * 100, label: label });
    });
    out.sort(function (a, b) { return a.amt - b.amt; });
    return out;
  }

  function renderShippingBar(cart) {
    var total = merchTotal(cart); /* sin protección · la protección no cuenta para envío gratis */
    var achievedShip = total >= THR;
    var bar = $('[data-ecd-bar]');
    var fill = $('[data-ecd-bar-fill]');
    var prog = $('[data-ecd-progress-tx]');
    var progWrap = $('.ecd__progress');
    var giftHint = $('[data-ecd-gift-hint]');
    var tiers = getGiftTiers();

    /* ── Escala SEGMENTADA (avanza de verdad) ──
       En vez de escalar a un máximo lejano (que apenas se movía), la barra mide el
       progreso hacia el SIGUIENTE hito y se rellena dentro de ese tramo. Hitos:
       envío gratis (THR) + cada regalo. Siempre avanza visiblemente. */
    var milestones = [{ amt: THR, type: 'ship', label: 'envío gratis' }];
    tiers.forEach(function (t) { milestones.push({ amt: t.amt, type: 'gift', label: t.label }); });
    milestones.sort(function (a, b) { return a.amt - b.amt; });

    var next = null, prevAmt = 0;
    for (var i = 0; i < milestones.length; i++) {
      if (total < milestones[i].amt) { next = milestones[i]; break; }
      prevAmt = milestones[i].amt;
    }

    if (bar) bar.classList.toggle('is-done', achievedShip);
    if (progWrap) progWrap.classList.toggle('is-done', achievedShip);

    if (!next) {
      /* Todos los hitos alcanzados */
      if (fill) fill.style.width = '100%';
      if (prog) prog.innerHTML = tiers.length ? '<b>¡Todo desbloqueado!</b> envío gratis + regalos' : 'Listo, <b>envío gratis</b> incluido';
      if (achievedShip) triggerConfettiOnce();
    } else {
      var segPct = Math.round(((total - prevAmt) / (next.amt - prevAmt)) * 100);
      if (fill) fill.style.width = (segPct < 4 ? 4 : Math.min(100, segPct)) + '%';
      var remaining = next.amt - total;
      if (prog) {
        if (next.type === 'ship') {
          prog.innerHTML = total === 0
            ? 'Súmale <b>' + money(THR) + '</b> y el envío va por nuestra cuenta'
            : 'Te faltan <b>' + money(remaining) + '</b> para envío <b>gratis</b>';
        } else {
          prog.innerHTML = '<b>' + money(remaining) + '</b> más y sumas: ' + escapeHtml(next.label);
        }
      }
      if (achievedShip) triggerConfettiOnce();
    }

    /* Gift hint: regalos YA sumados (acumulables) — refuerzo positivo */
    if (giftHint) {
      var unlocked = tiers.filter(function (t) { return total >= t.amt; });
      if (unlocked.length) {
        /* Sin emoji · SVG de regalo (line-style, coherente con el drawer) */
        giftHint.innerHTML = '<svg class="ecd__gift-ic" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg> Ya sumaste de regalo: <b>' +
          unlocked.map(function (t) { return escapeHtml(t.label); }).join(' + ') + '</b>';
        giftHint.hidden = false;
      } else {
        giftHint.hidden = true;
      }
    }

    /* One-tap "súmale 1 → envío gratis": aparece SOLO si agregar 1 pieza de la línea
       más barata (sin contar protección) cruza el umbral. Reusa setQtyOptimistic → sin recarga. */
    var topup = $('[data-ecd-bar-topup]');
    if (topup) {
      var cand = null;
      if (next && next.type === 'ship') {
        (cart.items || []).forEach(function (it) {
          if (isProtection(it)) return;
          var unit = Math.round((it.final_line_price || 0) / Math.max(1, it.quantity));
          if (unit > 0 && (total + unit) >= THR && (!cand || unit < cand.unit)) {
            cand = { key: it.key, unit: unit, title: it.product_title || it.title };
          }
        });
      }
      if (cand) {
        topup.innerHTML = '<span class="ecd__topup-tx">Súmale <b>1</b> de ' + escapeHtml(shortName(cand.title)) + ' y tu envío es <b>GRATIS</b></span><span class="ecd__topup-go" aria-hidden="true">Sumar +1</span>';
        topup.setAttribute('data-key', cand.key);
        topup.hidden = false;
      } else {
        topup.hidden = true;
        topup.removeAttribute('data-key');
      }
    }

    /* IMPERATIVO: anota los regalos acumulados en la nota del pedido (para empaque). */
    updateGiftNote(cart);
  }

  /* ──────────────────────────────────────────────────────────────────
     BARRA DE DESCUENTO POR VOLUMEN (premium · glass navy/azul · sin emojis)
     ──────────────────────────────────────────────────────────────────
     Informativa: cuenta SOLO unidades de los 4 productos individuales (los
     protocolos/paquetes ya vienen pre-descontados y NO suman) y muestra el
     siguiente escalón de ahorro automático (2→5%, 3→8%, 4→10%). El descuento
     real lo aplica Shopify en checkout; aquí NO se inyectan códigos.
     Copy limpio/premium (sin gritar "% de descuento", framing de ahorro):
       1 ud  → "Suma 1 producto y ahorra 5%"        (barra hacia 2)
       2 uds → "Suma 1 producto y ahorra 8%"        (barra hacia 3)
       3 uds → "Suma 1 producto y ahorra 10%"       (barra hacia 4)
       4+ uds→ "Ahorro por volumen activo, 10%"     (lleno + check)
     Convive con la barra de envío SIN saturar: se apila DEBAJO de .ecd__progress
     con jerarquía visual menor (más compacta, color propio navy). Se oculta con
     0 unidades individuales (carrito vacío o solo protocolos). */
  function injectVolumeStyles() {
    if (document.getElementById('ecd-volbar-css')) return;
    var css = [
      '.ecd__vol{position:relative;margin:8px 14px 0;padding:10px 12px;border-radius:14px;',
      'background:rgba(14,27,77,.055);border:1px solid rgba(26,107,245,.16);',
      'box-shadow:inset 0 1px .5px rgba(255,255,255,.7),0 4px 14px -8px rgba(14,27,77,.18);',
      '-webkit-backdrop-filter:none;backdrop-filter:none;',
      'font-family:inherit;overflow:hidden}',
      '.ecd__vol[hidden]{display:none}',
      '.ecd__vol::before{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;',
      'background:linear-gradient(135deg,rgba(255,255,255,.30) 0%,rgba(255,255,255,0) 40%)}',
      '.ecd__vol-head{position:relative;z-index:1;display:flex;align-items:center;gap:7px;margin-bottom:8px}',
      '.ecd__vol-ic{display:inline-flex;color:#1A6BF5;flex:0 0 auto}',
      '.ecd__vol-tx{font-size:12.5px;line-height:1.3;color:#0E1B4D;letter-spacing:.1px}',
      '.ecd__vol-tx b{font-weight:700;color:#0E1B4D}',
      '.ecd__vol-track{position:relative;z-index:1;height:6px;border-radius:99px;background:rgba(14,27,77,.10);overflow:hidden}',
      '.ecd__vol-fill{height:100%;border-radius:99px;width:0;',
      'background:linear-gradient(90deg,#1A6BF5,#0E1B4D);transition:width .45s cubic-bezier(.16,1,.3,1)}',
      '.ecd__vol.is-max .ecd__vol-fill{background:linear-gradient(90deg,#1A6BF5,#16B364)}',
      '.ecd__vol.is-max .ecd__vol-ic{color:#16B364}',
      /* CHIP secundario sutil (cuando el envío gratis ya está logrado): más compacto,
         sin track ancho, jerarquía menor. Nunca compite con la barra de envío. */
      '.ecd__vol.is-chip{margin:6px 14px 0;padding:7px 11px;border-radius:99px;',
      'background:rgba(14,27,77,.04);box-shadow:none;backdrop-filter:none;-webkit-backdrop-filter:none}',
      '.ecd__vol.is-chip::before{display:none}',
      '.ecd__vol.is-chip .ecd__vol-head{margin-bottom:0}',
      '.ecd__vol.is-chip .ecd__vol-tx{font-size:11.5px}',
      '.ecd__vol.is-chip .ecd__vol-track{display:none}'
    ].join('');
    var st = document.createElement('style');
    st.id = 'ecd-volbar-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function ensureVolumeBar() {
    var el = $('[data-ecd-vol]');
    if (el) return el;
    var anchor = $('.ecd__progress');
    if (!anchor || !anchor.parentNode) return null;
    injectVolumeStyles();
    el = document.createElement('div');
    el.className = 'ecd__vol';
    el.setAttribute('data-ecd-vol', '1');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="ecd__vol-head">' +
        '<span class="ecd__vol-ic" data-ecd-vol-ic aria-hidden="true"></span>' +
        '<span class="ecd__vol-tx" data-ecd-vol-tx></span>' +
      '</div>' +
      '<div class="ecd__vol-track"><div class="ecd__vol-fill" data-ecd-vol-fill></div></div>';
    /* Justo DEBAJO de la barra de envío, antes del cuerpo scrolleable. */
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }

  var VOL_IC_TAG =
    '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4"/><path d="M12 11v10"/></svg>';
  var VOL_IC_CHECK =
    '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  function renderVolumeBar(cart) {
    /* DESACTIVADO · EPIC no tiene descuentos por volumen. 2026-09-04.
       Si se reactiva, retirar este bloque. */
    var _volEl = $('[data-ecd-vol]');
    if (_volEl) _volEl.hidden = true;
    return;

    /* ── Paquete/protocolo en el carrito → OCULTAR la barra de volumen ──
       La escalera de volumen es para APILAR productos sueltos. Los paquetes ya
       traen su descuento horneado en el precio: el nudge "Suma 1 y ahorra X%"
       no aplica y confunde. La oferta de SUBIR de tier la maneja el smart offer
       engine (escalationTarget), no esta barra. */
    if (cartHasPackage(cart)) { el.hidden = true; el.classList.remove('is-max'); return; }

    /* Solo unidades de los 4 productos individuales cuentan para el volumen.
       Los protocolos/paquetes ya vienen pre-descontados → no aplican. */
    var qty = volumeUnitCount(cart);

    /* ── UN SOLO objetivo de progreso a la vez (pedido de Roberto · declutter) ──
       Mientras el cliente NO ha llegado a envío gratis, la barra de envío es la
       ÚNICA barra prominente. La de volumen NO compite como segunda barra ancha:
       se oculta hasta que el envío gratis ya esté logrado. Una vez logrado el envío,
       el "ahorra X%" aparece como secundario sutil (chip compacto, clase is-chip). */
    var shipDone = merchTotal(cart) >= THR;
    if (!shipDone) { el.hidden = true; el.classList.remove('is-max'); return; }
    el.classList.add('is-chip'); /* jerarquía visual menor: secundario sutil */

    /* Sin productos individuales → ocultar (carrito vacío, solo protocolos, o solo protección). */
    if (qty < 1) { el.hidden = true; el.classList.remove('is-max'); return; }
    el.hidden = false;

    var icEl = $('[data-ecd-vol-ic]', el);
    var txEl = $('[data-ecd-vol-tx]', el);
    var fillEl = $('[data-ecd-vol-fill]', el);
    var maxTier = VOLUME_TIERS[VOLUME_TIERS.length - 1];

    /* Estado logrado: 4+ piezas → tope alcanzado. */
    if (qty >= maxTier.qty) {
      el.classList.add('is-max');
      if (icEl) icEl.innerHTML = VOL_IC_CHECK;
      if (txEl) txEl.innerHTML = 'Ahorro por volumen activo, <b>' + maxTier.pct + '%</b>';
      if (fillEl) fillEl.style.width = '100%';
      return;
    }

    el.classList.remove('is-max');
    if (icEl) icEl.innerHTML = VOL_IC_TAG;

    /* Buscar el siguiente escalón por encima de la cantidad actual. */
    var next = null, prevQty = 0;
    for (var i = 0; i < VOLUME_TIERS.length; i++) {
      if (qty < VOLUME_TIERS[i].qty) { next = VOLUME_TIERS[i]; break; }
      prevQty = VOLUME_TIERS[i].qty;
    }
    if (!next) { el.hidden = true; return; }

    var need = next.qty - qty;
    var piece = need === 1 ? 'producto' : 'productos';
    var msg;
    if (need === 1) {
      msg = 'Suma 1 producto y ahorra <b>' + next.pct + '%</b>';
    } else {
      msg = 'Suma ' + need + ' productos y ahorra <b>' + next.pct + '%</b>';
    }
    if (txEl) txEl.innerHTML = msg;

    /* Relleno dentro del tramo prevQty→next.qty (siempre visible mínimo). */
    var segPct = Math.round(((qty - prevQty) / (next.qty - prevQty)) * 100);
    if (fillEl) fillEl.style.width = Math.max(8, Math.min(100, segPct)) + '%';
  }

  /* ──────────────────────────────────────────────────────────────────
     REGALOS POR MONTO → NOTA DEL PEDIDO
     El regalo NO se agrega como producto (inflaría métricas / "más vendidos").
     En su lugar se escribe en la NOTA del pedido (+ attribute de respaldo) EXACTAMENTE
     qué regalos lleva, de forma ACUMULABLE, para que empaque los incluya.
     · Idempotente: bloque delimitado; preserva la nota del cliente.
     · Usa fetchJSON (fetch nativo) → no dispara el interceptor.
     ────────────────────────────────────────────────────────────────── */
  var GIFT_OPEN = '== REGALOS A INCLUIR ==';
  var GIFT_CLOSE = '== FIN REGALOS ==';
  var GIFT_ATTR = 'Regalos a incluir';

  function stripGiftBlock(note) {
    if (!note) return '';
    var oi = note.indexOf(GIFT_OPEN);
    if (oi === -1) return note;
    var ci = note.indexOf(GIFT_CLOSE, oi);
    /* FIX audit #23 · solo removemos un bloque COMPLETO (open + close). Si falta el cierre,
       probablemente es texto del cliente que casualmente contiene el delimitador → NO lo
       tocamos (evita mangle de la nota del cliente y el loop de re-escritura). */
    if (ci === -1) return note;
    var before = note.slice(0, oi).replace(/\s+$/, '');
    var after = note.slice(ci + GIFT_CLOSE.length).replace(/^\s+/, '');
    return (before + (before && after ? '\n\n' : '') + after).trim();
  }

  function computeUnlockedGifts(cart) {
    var total = merchTotal(cart); /* regalos por monto de MERCANCÍA (sin protección) */
    return getGiftTiers().filter(function (t) { return total >= t.amt; });
  }

  function updateGiftNote(cart) {
    if (!cart) return Promise.resolve();
    var tiers = getGiftTiers();
    if (!tiers.length) return Promise.resolve(); /* sin regalos configurados → no tocar la nota */

    var unlocked = computeUnlockedGifts(cart);
    var base = stripGiftBlock(cart.note || '');
    var block = unlocked.length
      ? (GIFT_OPEN + '\n' + unlocked.map(function (t) { return '• ' + t.label; }).join('\n') + '\n(acumulables · por monto de compra)\n' + GIFT_CLOSE)
      : '';
    var newNote = block ? (base ? base + '\n\n' + block : block) : base;
    var attrVal = unlocked.length ? unlocked.map(function (t) { return t.label; }).join(' + ') : '';
    var curAttr = (cart.attributes && cart.attributes[GIFT_ATTR]) || '';

    /* Skip si nada cambió → evita spam de /cart/update.js y loops */
    if (newNote === (cart.note || '') && attrVal === curAttr) return Promise.resolve();
    /* FIX audit #23 · guard anti-concurrencia: una sola escritura de nota a la vez */
    if (STATE._giftNoteBusy) return Promise.resolve();
    STATE._giftNoteBusy = true;

    var attrs = {}; attrs[GIFT_ATTR] = attrVal;
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: newNote, attributes: attrs })
    }).then(function () {
      cart.note = newNote;
      if (!cart.attributes) cart.attributes = {};
      cart.attributes[GIFT_ATTR] = attrVal;
      if (STATE.cart && STATE.cart !== cart) {
        STATE.cart.note = newNote;
        if (!STATE.cart.attributes) STATE.cart.attributes = {};
        STATE.cart.attributes[GIFT_ATTR] = attrVal;
      }
      STATE._giftNoteBusy = false;
    }).catch(function () { STATE._giftNoteBusy = false; /* no romper el render si falla */ });
  }

  function renderTotals(cart) {
    var sub = $('[data-ecd-subtotal]');
    var ship = $('[data-ecd-ship]');
    var total = $('[data-ecd-total]');
    var saveRow = $('[data-ecd-row-save]');
    var saveEl = $('[data-ecd-save]');

    /* El Shaker se cobra a $129 al pagar (código SHAKERBB129). Mostramos el total NETO
       que de verdad pagará el cliente para que el carrito no mienta con $299. */
    var shaSav = shakerSaving(cart);
    var subNet = Math.max(0, (cart.items_subtotal_price || cart.total_price || 0) - shaSav);
    var totalNet = Math.max(0, (cart.total_price || 0) - shaSav);

    if (sub) sub.textContent = money(subNet);
    if (total) total.textContent = money(totalNet);

    if (ship) {
      var achieved = merchTotal(cart) >= THR; /* envío gratis por MERCANCÍA (sin protección) */
      if (achieved) {
        ship.textContent = 'GRATIS';
        ship.classList.add('ecd__free');
      } else {
        ship.textContent = money(FEE);
        ship.classList.remove('ecd__free');
      }
    }

    /* ahorros: descuentos de línea/bundle + suscripción + promo del Shaker */
    var savings = ((cart.original_total_price || 0) - (cart.total_price || 0)) + subscriptionSavings(cart) + shaSav;
    if (savings > 0 && saveRow && saveEl) {
      saveRow.hidden = false;
      saveEl.textContent = money(savings);
    } else if (saveRow) {
      saveRow.hidden = true;
    }
  }

  /* ──────────────────────────────────────────────────────────────────
     SMART OFFER ENGINE
     Una sola card adaptativa según el estado del carrito.
     NO duplica el popup post-PDP de Kaching: este motor SIEMPRE propone
     otra capa (cross-sell a Protocolo, upsell a Suscripción, o downsell Shaker).
     ────────────────────────────────────────────────────────────────── */
  function pickOffer(cart) {
    if (!cart || cart.item_count === 0) return null;
    /* Cuenta SOLO mercancía (la protección es una línea oculta y no debe contar como "producto") */
    var merch = (cart.items || []).filter(function (it) { return !isProtection(it); });
    if (merch.length === 0) return null;
    var lines = merch.length;
    var hasSub = cart.items.some(function (it) { return !!it.selling_plan_allocation; });
    var hasProtocol = cart.items.some(function (it) {
      var t = (it.product_title || '') + ' ' + (it.handle || '');
      return /protocol|bundle|pack/i.test(t);
    });
    var hasShaker = cart.items.some(function (it) {
      return /shaker/i.test(it.product_title || '');
    });

    /* PRIORIDAD 0 · PAQUETE / PROTOCOLO en el carrito → ESCALAR, no apilar piezas.
       Un paquete ya trae su descuento horneado: no le ofrecemos "suma 1 producto"
       ni volumen. Le ofrecemos SUBIR al protocolo superior (enmarcado por VALOR:
       más sistemas en sincronía), o directo al Elite. Si el Elite ya está en el
       carrito (escalationTarget === null), es terminal: no se ofrece escalón y se
       deja seguir con el resto del motor (suscripción/shaker/cross-sell). */
    if (cartHasPackage(cart)) {
      var esc = escalationTarget(cart);
      if (esc) return escalateOffer(esc);
    }

    /* PRIORIDAD 1 · cross-sell complementario por VALOR (producto relacionado real).
       La suscripción se ofrece directamente en la PDP — no en el carrito.
       Framing: "esto va muy bien con lo que llevas" (ciencia, no incentivo de precio). */
    if (STATE.crossSell && STATE.crossSell.variant_id && !cartHasProduct(cart, STATE.crossSell.product_id)) {
      return crossSellOffer(STATE.crossSell);
    }

    /* PRIORIDAD 3 · downsell SHAKER · MISMO patrón del bundle/hotsale builder.
       Precio real del Shaker = STATE.shakerListPrice (Shopify price en centavos).
       El cliente verá $XXX tachado y "$129 al checkout" — el código SHAKERBB129
       se cadena automático al pulsar "Ir a pagar". */
    if (!hasShaker) {
      var listMoney = STATE.shakerListPrice ? money(STATE.shakerListPrice) : null;
      return {
        type: 'shaker',
        tag: 'SOLO AQUÍ, $129',
        save: listMoney ? 'antes ' + listMoney : null,
        title: 'El shaker oficial al checkout, $129',
        d: '600 ml. Sin grumos. Descuento se aplica al ir a pagar.',
        was: listMoney,        /* precio real tachado */
        now: SHAKER_PROMO_PRICE, /* precio prometido $129 */
        btn: 'Súmalo',
        action: 'add-shaker'
      };
    }

    /* Estado terminal (carrito con protocolo + suscripción + shaker) — nada por mejorar */
    return null;
  }

  function renderOffer(cart) {
    var box = $('[data-ecd-offer]');
    if (!box) return;
    loadCrossSell(cart);           /* dispara/actualiza la recomendación real (async, idempotente) */
    var offer = pickOffer(cart);
    if (!offer) { box.hidden = true; box.removeAttribute('data-type'); return; }

    box.hidden = false;
    box.setAttribute('data-type', offer.type);

    var setT = function (sel, val) { var el = $(sel); if (el) el.textContent = val; };
    var setH = function (sel, val) { var el = $(sel); if (el) el.hidden = !val; };

    setT('[data-ecd-offer-tag]', offer.tag || '');
    setT('[data-ecd-offer-title]', offer.title || '');
    setT('[data-ecd-offer-d]', offer.d || '');
    setT('[data-ecd-offer-btn-tx]', offer.btn || 'Agregar');

    if (offer.save) {
      setT('[data-ecd-offer-save]', offer.save);
      setH('[data-ecd-offer-save]', true);
    } else { setH('[data-ecd-offer-save]', false); }

    if (offer.now) {
      setH('[data-ecd-offer-price]', true);
      setT('[data-ecd-offer-was]', offer.was || '');
      setT('[data-ecd-offer-now]', offer.now);
    } else { setH('[data-ecd-offer-price]', false); }

    /* Bind del botón vía datasets */
    var btn = $('[data-ecd-offer-btn]');
    if (btn) {
      btn.classList.remove('is-added');
      btn.setAttribute('data-action', offer.action || '');
      btn.setAttribute('data-href', offer.href || '');
    }

    /* Imagen/ícono de la oferta.
       shaker/crosssell → FOTO de producto (paint*). protocol/subscribe → ÍCONO SVG.
       FIX: paint* reemplaza TODO el [data-ecd-offer-img] con un <img>, borrando el
       [data-ecd-offer-icon]. Si la oferta volvía a subscribe/protocol, el <img> del shaker
       se quedaba pegado ("la suscripción tenía foto del shaker"). Ahora, para los tipos de
       ÍCONO, reconstruimos el SVG (quitando cualquier <img>) de forma idempotente. */
    if (offer.type === 'shaker') {
      loadShaker();
    } else if (offer.type === 'crosssell') {
      paintCrossSell();
    } else {
      var imgBox = $('[data-ecd-offer-img]');
      if (imgBox) {
        var icon = imgBox.querySelector('[data-ecd-offer-icon]');
        if (imgBox.querySelector('img') || !icon) {
          /* había una foto pegada (o se borró el SVG) → reconstruir el contenedor del ícono */
          imgBox.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" data-ecd-offer-icon></svg>';
          icon = imgBox.querySelector('[data-ecd-offer-icon]');
        }
        if (icon) {
          if (offer.type === 'protocol') {
            icon.innerHTML = '<polyline points="20 7 9 18 4 13"/><path d="M16 3v4M21 8h-4"/>';
          } else if (offer.type === 'subscribe') {
            icon.innerHTML = '<polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/>';
          }
        }
      }
    }
  }

  /* Lazy-load del Shaker.
     /search/suggest.json devuelve variants: [] vacío — solo nos da el handle.
     Después fetcheamos /products/HANDLE.js para variants reales. Fallback hardcoded a 'epic-shaker'. */
  function loadShaker() {
    if (STATE.shakerLoaded) { paintShaker(); return Promise.resolve(); }
    return fetchJSON('/search/suggest.json?q=shaker&resources[type]=product&resources[limit]=1')
      .then(function (data) {
        var ps = data && data.resources && data.resources.results && data.resources.results.products;
        var p = ps && ps[0];
        var handle = (p && p.handle) || 'epic-shaker';
        return fetchJSON('/products/' + handle + '.js');
      })
      .then(function (product) {
        STATE.shakerVariantId = product.variants && product.variants[0] && product.variants[0].id;
        var img = product.featured_image || (product.images && product.images[0]);
        STATE.shakerImage = typeof img === 'string' ? img : (img && img.src);
        /* Precio REAL del Shaker (Shopify price está en centavos) */
        STATE.shakerListPrice = product.price; /* ej. 29900 = $299 */
        STATE.shakerLoaded = true;
        paintShaker();
        /* Re-render del offer para reflejar precio real (si el offer ya estaba pintado con placeholder) */
        if (STATE.cart) renderOffer(STATE.cart);
      })
      .catch(function (err) { console.warn('[EPIC] shaker load failed', err); });
  }
  function paintShaker() {
    var img = $('[data-ecd-offer-img]');
    if (!img || !STATE.shakerImage) return;
    var box = $('[data-ecd-offer]');
    if (!box || box.getAttribute('data-type') !== 'shaker') return;
    /* IDEMPOTENTE · si ya está la MISMA imagen, no recrear el <img>.
       Antes: innerHTML= en cada render -> el browser re-fetcheaba la foto -> parpadeo del shaker. */
    var targetSrc = img2x(STATE.shakerImage, 120);
    var cur = img.querySelector('img');
    if (cur && cur.getAttribute('src') === targetSrc) return;
    img.innerHTML = '<img src="' + targetSrc + '" alt="" width="50" height="50" loading="lazy" decoding="async">';
  }

  /* ── CROSS-SELL INTELIGENTE ────────────────────────────────────────────
     Recomendación REAL vía la API nativa de Shopify (/recommendations/products.json)
     según el producto que ya lleva el carrito. Cero mantenimiento, datos reales.
     Al agregar usa /cart/add.js → el pixel nativo dispara add_to_cart en TODAS las
     plataformas; NO metemos gtag/fbq a mano (evita el doble-disparo que ya quitamos). */
  function cartHasProduct(cart, productId) {
    if (!cart || !productId) return false;
    return (cart.items || []).some(function (it) { return it.product_id === productId; });
  }

  /* MAPA CURADO MULTI-TARGET — buyer-persona aware (2026-09-12).
     Cada handle tiene: targets[] en orden de prioridad (primero que NO esté en el
     carrito se usa), tag copy y msgs{} con descripción específica por target.
     Persona Optimizador Exigente: PUMPX/COREX → recovery (BIOMAG/CREANOVA).
     Persona Profesionista: BIOMAG/CREANOVA → creatina o pre-entreno. */
  var CROSS_SELL_MAP = {
    'bio-mag-magnesio-glicinato-recuperacion-rendimiento': {
      targets: [
        'creanova-creatina-monohidratada-vitamina-b6-alta-absorcion',
        'pump-x-preentreno-sin-estimulantes-bombeo-enfoque'
      ],
      tag: 'COMPLETA TU PROTOCOLO',
      msgs: {
        'creanova-creatina-monohidratada-vitamina-b6-alta-absorcion': 'La creatina que maximiza lo que el magnesio ya inició.',
        'pump-x-preentreno-sin-estimulantes-bombeo-enfoque': 'Pre-entreno limpio para el día que ya recuperas bien.'
      }
    },
    'core-x-formula-rendimiento-elite': {
      targets: [
        'bio-mag-magnesio-glicinato-recuperacion-rendimiento',
        'creanova-creatina-monohidratada-vitamina-b6-alta-absorcion'
      ],
      tag: 'RECUPERA IGUAL DE DURO',
      msgs: {
        'bio-mag-magnesio-glicinato-recuperacion-rendimiento': 'Magnesio glicinato: el recovery stack del rendimiento real.',
        'creanova-creatina-monohidratada-vitamina-b6-alta-absorcion': 'Creatina clínica para mantener el nivel que construyes.'
      }
    },
    'creanova-creatina-monohidratada-vitamina-b6-alta-absorcion': {
      targets: [
        'bio-mag-magnesio-glicinato-recuperacion-rendimiento',
        'pump-x-preentreno-sin-estimulantes-bombeo-enfoque'
      ],
      tag: 'SINERGIA CLÍNICA',
      msgs: {
        'bio-mag-magnesio-glicinato-recuperacion-rendimiento': 'Magnesio que potencia la absorción y mejora el sueño profundo.',
        'pump-x-preentreno-sin-estimulantes-bombeo-enfoque': 'Pre-entreno para aprovechar la fuerza que la creatina construye.'
      }
    },
    'pump-x-preentreno-sin-estimulantes-bombeo-enfoque': {
      targets: [
        'core-x-formula-rendimiento-elite',
        'bio-mag-magnesio-glicinato-recuperacion-rendimiento'
      ],
      tag: 'STACK COMPLETO',
      msgs: {
        'core-x-formula-rendimiento-elite': 'El rendimiento elite que amplifica cada sesión de PUMPX.',
        'bio-mag-magnesio-glicinato-recuperacion-rendimiento': 'Recupera a la misma velocidad que entrenas.'
      }
    }
  };
  /* Alias legacy por compatibilidad — no se usa con la nueva lógica */
  var CROSS_SELL_PAIR = {};

  /* handle del line item (con fallback a parsear la URL, como en otras partes) */
  function lineHandle(it) {
    if (!it) return '';
    return it.handle || (it.url && it.url.split('/products/')[1] && it.url.split('/products/')[1].split('?')[0]) || '';
  }

  function loadCrossSell(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    /* semilla = primer item de mercancía (prefiere NO-shaker / NO-protección) */
    var seedItem = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isProtection(it)) continue;
      if (/shaker/i.test(it.product_title || '')) { if (!seedItem) seedItem = it; continue; }
      seedItem = it; break;
    }
    if (!seedItem || !seedItem.product_id) return;
    var seed = seedItem.product_id;
    if (seed === STATE._crossSellSeed || STATE._crossSellBusy) return;
    STATE._crossSellBusy = true;
    var inCartHandles = {};
    (cart.items || []).forEach(function (x) { var h = lineHandle(x); if (h) inCartHandles[h] = true; });

    /* ── 1) Mapa curado multi-target (buyer-persona aware): itera targets[] hasta encontrar uno no en carrito ── */
    var seedHandle = lineHandle(seedItem);
    var mapEntry = CROSS_SELL_MAP[seedHandle];
    if (mapEntry && mapEntry.targets) {
      var targetHandle = null;
      for (var ti = 0; ti < mapEntry.targets.length; ti++) {
        if (!inCartHandles[mapEntry.targets[ti]]) { targetHandle = mapEntry.targets[ti]; break; }
      }
      if (targetHandle) {
        var _tag = mapEntry.tag;
        var _msg = (mapEntry.msgs && mapEntry.msgs[targetHandle]) || null;
        fetchJSON('/products/' + targetHandle + '.js')
          .then(function (product) {
            STATE._crossSellSeed = seed;
            var v = null, vs = (product && product.variants) || [];
            for (var k = 0; k < vs.length; k++) { if (vs[k] && vs[k].available) { v = vs[k]; break; } }
            v = v || vs[0];
            if (v) {
              var im = product.featured_image || (product.images && product.images[0]);
              STATE.crossSell = {
                variant_id: v.id,
                product_id: product.id,
                title: product.title,
                image: typeof im === 'string' ? im : (im && im.src) || null,
                price: product.price,
                handle: product.handle,
                personaTag: _tag,
                personaMsg: _msg
              };
            } else { STATE.crossSell = null; }
            STATE._crossSellBusy = false;
            if (STATE.cart) { try { renderOffer(STATE.cart); } catch (e) {} }
          })
          .catch(function () { STATE._crossSellSeed = seed; STATE._crossSellBusy = false; });
        return;
      }
      /* todos los targets ya en carrito → cae al genérico abajo */
    }

    /* ── 2) Genérico (recomendaciones nativas de Shopify) ── */
    fetchJSON('/recommendations/products.json?intent=related&limit=10&product_id=' + seed)
      .then(function (data) {
        STATE._crossSellSeed = seed;
        /* FIX: reconstruir inCart al momento del callback (el carrito pudo cambiar desde que se lanzó el fetch) */
        var freshInCart = {};
        ((STATE.cart && STATE.cart.items) || []).forEach(function (x) { freshInCart[x.product_id] = true; });
        var prods = (data && data.products) || [];
        var pick = null, fallback = null;
        for (var j = 0; j < prods.length; j++) {
          var p = prods[j];
          if (!p || !p.variants || !p.variants[0]) continue;
          if (freshInCart[p.id]) continue;                              /* ya está en el carrito (check fresco) */
          if (p.handle === 'proteccion-de-envio-epic') continue;
          if (/shaker/i.test(p.handle || p.title || '')) continue;       /* el shaker tiene su card */
          if ((p.price || 0) <= 0) continue;
          if (!fallback) fallback = p;
          if (!/protocolo|paquete|bundle|pack/i.test(p.title || '')) { pick = p; break; } /* prefiere suelto */
        }
        pick = pick || fallback;
        if (pick) {
          var im = pick.featured_image || (pick.images && pick.images[0]);
          STATE.crossSell = {
            variant_id: pick.variants[0].id,
            product_id: pick.id,
            title: pick.title,
            image: typeof im === 'string' ? im : (im && im.src) || null,
            price: pick.price,
            handle: pick.handle
          };
        } else { STATE.crossSell = null; }
        STATE._crossSellBusy = false;
        if (STATE.cart) { try { renderOffer(STATE.cart); } catch (e) {} }
      })
      .catch(function () { STATE._crossSellSeed = seed; STATE._crossSellBusy = false; });
  }

  function paintCrossSell() {
    var img = $('[data-ecd-offer-img]');
    if (!img || !STATE.crossSell || !STATE.crossSell.image) return;
    var box = $('[data-ecd-offer]');
    if (!box || box.getAttribute('data-type') !== 'crosssell') return;
    var targetSrc = img2x(STATE.crossSell.image, 120);
    var cur = img.querySelector('img');
    if (cur && cur.getAttribute('src') === targetSrc) return;
    img.innerHTML = '<img src="' + targetSrc + '" alt="" width="50" height="50" loading="lazy" decoding="async">';
  }

  /* Acorta el título a tamaño de tarjeta (corta en el primer separador fuerte) */
  function shortName(t) {
    if (!t) return '';
    var s = String(t).split(/[·|]/)[0].trim();
    if (s.length > 38) s = s.slice(0, 36).trim() + '…';
    return s;
  }

  function crossSellOffer(cs) {
    return {
      type: 'crosssell',
      tag: cs.personaTag || 'COMPLETA TU PROTOCOLO',
      title: shortName(cs.title),
      d: cs.personaMsg || 'Va de la mano con lo que llevas. Bien dosificado.',
      now: money(cs.price),
      btn: 'Sumar',
      action: 'add-crosssell'
    };
  }

  /* Oferta de ESCALAR de protocolo (enmarcada por VALOR, no por envío ni volumen).
     Lleva al PDP del paquete superior (Elite). Usa la acción href: al pulsar,
     navega y cierra el drawer. type:'protocol' → ícono de check (no foto). */
  function escalateOffer(tier) {
    var toElite = tier.next === ELITE_HANDLE;
    return {
      type: 'protocol',
      tag: 'SUBE DE NIVEL',
      title: toElite ? 'Sube a Protocolo Elite, los 4 sistemas en sincronía'
                     : 'Sube a ' + tier.nextName + ', más sistemas en sincronía',
      d: toElite ? 'El sistema completo EPIC. Energía, fuerza, enfoque y recuperación trabajando juntos.'
                 : 'Lleva tu rendimiento al siguiente protocolo, con mejor relación de valor.',
      btn: 'Subir',
      action: 'go-href',
      href: '/products/' + tier.next
    };
  }

  /* ──────────────────────────────────────────────────────────────────
     SHIPPING PROTECTION TOGGLE · Route App pattern
     Agrega/quita el variant "Protección de envío" del carrito al togglear.
     Prendido por defecto (opt-out) para take-rate ~80%. El cliente lo apaga
     conscientemente si no lo quiere — no es engaño, es default sensato.
     ────────────────────────────────────────────────────────────────── */
  function getProtectionVariantId() {
    var box = $('[data-ecd-protect]');
    return box ? box.getAttribute('data-variant-id') : null;
  }
  function findProtectionInCart(cart) {
    /* FIX audit #6 · detección UNIFICADA con isProtection (handle/product_type), no solo
       variant_id. Antes: si el variant del setting no coincidía con el real, el toggle
       "no la veía" (decía OFF aunque estuviera cobrada) y la re-agregaba en bucle. */
    if (!cart || !cart.items) return null;
    var byType = cart.items.find(function (it) { return isProtection(it); });
    if (byType) return byType;
    var vid = getProtectionVariantId();
    if (!vid) return null;
    return cart.items.find(function (it) { return String(it.variant_id) === String(vid); });
  }
  function toggleProtection(shouldBeOn) {
    var box = $('[data-ecd-protect]');
    var vid = getProtectionVariantId();
    if (!box || !vid) return Promise.resolve();
    /* FIX doble-protección (pedido #1370): re-entrancy guard. Sin esto, 2 llamadas en carrera
       (auto-add del render + toggle, o dos refresh seguidos) ven STATE.cart sin la protección
       todavía → ambas hacen /cart/add → Shopify las FUSIONA en qty 2. El guard las serializa. */
    if (STATE._protectBusy) return Promise.resolve();
    var existing = findProtectionInCart(STATE.cart);
    if (shouldBeOn) {
      /* IDEMPOTENTE: si ya está, forzar qty=1 (nunca 2). Si no, agregar 1. */
      if (existing) {
        if ((existing.quantity || 0) === 1) { return Promise.resolve(); }
        STATE._protectBusy = true; box.classList.add('is-busy');
        return fetchJSON('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: existing.key, quantity: 1 })
        }).then(function () { return refresh(); }).finally(function () { box.classList.remove('is-busy'); STATE._protectBusy = false; });
      }
      STATE._protectBusy = true; box.classList.add('is-busy');
      return fetchJSON('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _epic_protect: '1' } }] })
      }).then(function () { return refresh(); }).finally(function () { box.classList.remove('is-busy'); STATE._protectBusy = false; });
    } else {
      /* QUITAR (cualquier qty) */
      if (!existing) { return Promise.resolve(); }
      STATE._protectBusy = true; box.classList.add('is-busy');
      return fetchJSON('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: existing.key, quantity: 0 })
      }).then(function () { return refresh(); }).finally(function () { box.classList.remove('is-busy'); STATE._protectBusy = false; });
    }
  }

  /* ── PROTECCIÓN RECURRENTE ──────────────────────────────────────────────
     Si el carrito tiene productos de SUSCRIPCIÓN y la protección está activa,
     la protección también se vuelve recurrente (lleva el plan de suscripción del
     propio producto de protección). En compra única, la protección queda única.
     El plan se LEE EN VIVO del producto (no se hardcodea) → si cambia, sigue solo. ── */
  var _protPlan; /* undefined=no leído · null=sin plan · número=id */
  function getProtectionPlanId(cb) {
    if (typeof _protPlan !== 'undefined') { cb(_protPlan); return; }
    fetch('/products/proteccion-de-envio-epic.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var id = null;
        (p.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (pl) { if (id == null) id = pl.id; }); });
        _protPlan = id; cb(id);
      }).catch(function () { _protPlan = null; cb(null); });
  }
  function cartHasSubscription(cart) {
    return !!(cart && cart.items && cart.items.some(function (it) {
      return it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && !isProtection(it);
    }));
  }
  function syncProtectionPlan(cart) {
    if (STATE._protectBusy) return;
    var line = findProtectionInCart(cart);
    if (!line) return;                                /* sin protección, nada que sincronizar */
    var wantSub = cartHasSubscription(cart);          /* el carrito es de suscripción */
    var hasPlan = !!(line.selling_plan_allocation && line.selling_plan_allocation.selling_plan);
    if (wantSub === hasPlan) return;                  /* ya está como debe (sin bucles) */
    getProtectionPlanId(function (planId) {
      if (wantSub && !planId) return;                 /* no hay plan que poner */
      if (STATE._protectBusy) return;
      STATE._protectBusy = true;
      fetchJSON('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 1, selling_plan: wantSub ? planId : null })
      }).then(function () { return refresh(); }).finally(function () { STATE._protectBusy = false; });
    });
  }
  /* Sync el checkbox UI con el estado real del carrito en cada render.
     Si el cart tiene la protección, el toggle se muestra ON. Si no, OFF.
     Si es la primera vez y el setting default_on=true, autoagregamos. */
  function renderProtection(cart) {
    var box = $('[data-ecd-protect]');
    if (!box) return;
    var input = $('[data-ecd-protect-input]');
    if (!input) return;
    var line = findProtectionInCart(cart);
    var present = !!line;
    /* RED DE SEGURIDAD · si una carrera dejó qty>1, la forzamos a 1 en el próximo render →
       el cliente NUNCA paga doble protección (corrige en vivo lo que pasó en el #1370). */
    if (line && (line.quantity || 0) > 1 && !STATE._protectBusy) {
      STATE._protectBusy = true;
      fetchJSON('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 1 })
      }).then(function () { return refresh(); }).finally(function () { STATE._protectBusy = false; });
      return;
    }
    var defaultOn = box.getAttribute('data-default-on') === 'true';
    /* Auto-agregar solo si: hay items en cart, default es ON, y aún no está, y no la quitó manualmente esta sesión */
    if (cart.item_count > 0 && cart.item_count > (present ? 1 : 0) && defaultOn && !present) {
      try {
        if (sessionStorage.getItem('ecd_protect_optout') === '1') { /* no auto-add */ }
        else {
          toggleProtection(true);
          input.checked = true;
          return;
        }
      } catch (e) {}
    }
    input.checked = present;
  }

  /* ──────────────────────────────────────────────────────────────────
     SUBSCRIBE IN-PLACE
     Convierte TODOS los items elegibles a suscripción sin redirect.
     Para cada item: lee /products/HANDLE.js, busca el selling_plan con mayor descuento,
     llama /cart/change.js con id, quantity y selling_plan.
     ────────────────────────────────────────────────────────────────── */
  /* SECUENCIAL · /cart/change.js regenera keys cuando muta el carrito.
     Cambia un item a la vez y SIEMPRE relee /cart.js entre cambios para tener keys frescos.
     Esta es la fix correcta vs el race condition que dejaba items sin convertir. */
  /* ── Selección del plan de suscripción por DEFAULT ──────────────────
     Regla del negocio (pedido del usuario):
       · Todos los productos → plan de 1 mes (entrega mensual).
       · Creanova NO tiene plan de 1 mes → cae a su intervalo más corto = 2 meses
         (nunca el de 6 meses, que era lo que pasaba al elegir "mayor descuento").
     Implementación genérica y auto-mantenible: se elige el plan con el intervalo de
     entrega MÁS CORTO. Si existe uno de exactamente 1 mes, ese gana siempre.
     Lee delivery.interval + delivery.frequency del config= JSON nativo de Shopify;
     si falta, infiere por el nombre del plan. */
  var _PLAN_UNIT_DAYS = { DAY: 1, WEEK: 7, MONTH: 30, YEAR: 365 };
  function planRankDays(plan) {
    var freq = null, interval = null;
    (plan.options || []).forEach(function (o) {
      var v = o && o.value;
      if (typeof v === 'string' && v.indexOf('delivery') > -1) {
        try {
          var c = JSON.parse(v.replace(/^config=/, ''));
          if (c.delivery) { freq = c.delivery.frequency; interval = c.delivery.interval; }
        } catch (e) { /* no era JSON parseable */ }
      }
    });
    if (freq != null && interval) {
      return freq * (_PLAN_UNIT_DAYS[String(interval).toUpperCase()] || 30);
    }
    /* Fallback: inferir por el nombre */
    var n = (plan.name || '').toLowerCase();
    var m = n.match(/(\d+)\s*(d[ií]a|semana|mes|a[nñ]o)/);
    if (m) {
      var num = parseInt(m[1], 10);
      var u = m[2];
      var ud = u.charAt(0) === 'd' ? 1 : (u.indexOf('sem') === 0 ? 7 : (u.indexOf('mes') === 0 ? 30 : 365));
      return num * ud;
    }
    if (/quincenal/.test(n)) return 15;
    if (/semanal|weekly/.test(n)) return 7;
    if (/mensual|monthly|cada mes/.test(n)) return 30;
    if (/bimestral/.test(n)) return 60;
    if (/trimestral|quarterly/.test(n)) return 90;
    if (/semestral/.test(n)) return 180;
    if (/anual|yearly/.test(n)) return 365;
    return 9999;
  }
  function pickDefaultPlan(product) {
    var best = null, bestRank = Infinity, oneMonth = null;
    (product.selling_plan_groups || []).forEach(function (grp) {
      (grp.selling_plans || []).forEach(function (plan) {
        var rank = planRankDays(plan);
        if (rank === 30 && oneMonth == null) oneMonth = plan.id; /* 1 mes exacto = prioridad */
        if (rank < bestRank) { bestRank = rank; best = plan.id; }
      });
    });
    return oneMonth || best; /* 1 mes si existe; si no, el intervalo más corto */
  }

  function subscribeAllItems() {
    if (!STATE.cart || !STATE.cart.items.length) return Promise.resolve(0);
    setBusy(true);
    var success = 0;
    /* Snapshot inicial: lista de variant_ids con su quantity (clave estable) */
    var targets = STATE.cart.items
      .filter(function (it) { return !it.selling_plan_allocation; })
      .map(function (it) {
        var handle = it.handle || (it.url && it.url.split('/products/')[1] && it.url.split('/products/')[1].split('?')[0]);
        return { variantId: it.variant_id, quantity: it.quantity, handle: handle };
      });

    function processOne(idx) {
      if (idx >= targets.length) return Promise.resolve();
      var t = targets[idx];
      if (!t.handle) return processOne(idx + 1);

      return fetchJSON('/products/' + t.handle + '.js').then(function (product) {
        /* Plan DEFAULT = 1 mes donde exista; Creanova → su intervalo más corto (2 meses) */
        var planId = pickDefaultPlan(product);
        if (!planId) return processOne(idx + 1);

        /* IMPORTANTE: relee /cart.js para conseguir el key fresco de este variant_id */
        return fetchJSON('/cart.js').then(function (freshCart) {
          var line = freshCart.items.find(function (it) {
            return it.variant_id === t.variantId && !it.selling_plan_allocation;
          });
          if (!line) return processOne(idx + 1);
          /* FIX audit #13 · usa la cantidad FRESCA de la línea (line.quantity), no el
             snapshot viejo (t.quantity) — si el cliente cambió la qty mientras convertía
             a suscripción, ya no se la pisamos. */
          return fetchJSON('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: planId })
          }).then(function () {
            success++;
            return processOne(idx + 1);
          });
        });
      }).catch(function () {
        /* error en un item — sigue con los demás */
        return processOne(idx + 1);
      });
    }

    return processOne(0).then(function () {
      setBusy(false);
      return refresh().then(function () { broadcastCartUpdate(); return success; });
    });
  }

  /* ──────────────────────────────────────────────────────────────────
     6. CART OPERATIONS (change qty, remove, add)
     ────────────────────────────────────────────────────────────────── */
  function changeQty(key, qty) {
    if (STATE.busy) return Promise.resolve();
    setBusy(true);
    vibrate(8);
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (cart) {
      STATE.cart = cart;
      render(cart);
      broadcastCartUpdate();
      setBusy(false);
      return cart;
    }).catch(function (err) {
      console.warn('[EPIC] changeQty failed', err);
      setBusy(false);
    });
  }

  /* ── Cantidad OPTIMISTA · número al instante, SIN overlay blanco ──────
     Problema: changeQty mostraba el overlay (.ecd__loading, blanco + blur a panel
     completo) y esperaba 1-2s a Shopify -> "se pone todo en blanco como si recargara".
     Ahora: el número y el badge cambian al instante; la red se debouncea por key
     (clicks rápidos coalescen en 1 request) y reconcilia con diff render (no toca
     imágenes ni hace blanco). El precio/total se ajustan en su lugar al responder. */
  function setQtyOptimistic(key, newQty) {
    newQty = Math.max(0, newQty | 0);
    /* 1 · número visible al instante */
    var row = ROOT.querySelector('[data-ecd-qty][data-key="' + cssEscape(key) + '"]');
    if (row) {
      var nEl = row.querySelector('[data-ecd-qty-n]');
      if (nEl) nEl.textContent = newQty;
    }
    /* 2 · badge optimista (delta sobre el último estado bueno) */
    try {
      if (STATE.cart) {
        var prev = 0;
        (STATE.cart.items || []).forEach(function (it) { if (it.key === key) prev = it.quantity; });
        var badge = $('[data-ecd-count]');
        if (badge) badge.textContent = Math.max(0, (STATE.cart.item_count || 0) + (newQty - prev));
      }
    } catch (e) {}
    /* 3 · commit debounceado por key */
    STATE._qtyTarget = STATE._qtyTarget || {};
    STATE._qtyTimers = STATE._qtyTimers || {};
    STATE._qtyTarget[key] = newQty;
    if (STATE._qtyTimers[key]) clearTimeout(STATE._qtyTimers[key]);
    STATE._qtyTimers[key] = setTimeout(function () {
      var q = STATE._qtyTarget[key];
      delete STATE._qtyTarget[key];
      delete STATE._qtyTimers[key];
      commitQty(key, q);
    }, 340);
  }

  function commitQty(key, qty) {
    /* Commit a Shopify SIN overlay. Reconcilia con diff render (precio/total en su lugar). */
    vibrate(6);
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (cart) {
      STATE.cart = cart;
      render(cart);
      broadcastCartUpdate();
      return cart;
    }).catch(function (err) {
      console.warn('[EPIC] commitQty failed', err);
      if (STATE.cart) { try { render(STATE.cart); } catch (e) {} } /* revertir a último estado bueno */
    });
  }

  function removeItem(key) {
    /* Guardar para undo · INCLUYE selling_plan + properties para regresar EXACTO como estaba
       (antes el "deshacer" devolvía un producto con suscripción como compra única). */
    var item = STATE.cart && STATE.cart.items.find(function (it) { return it.key === key; });
    if (item) STATE.removedQueue.push({
      qty: item.quantity, id: item.variant_id, title: item.product_title,
      selling_plan: (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) ? item.selling_plan_allocation.selling_plan.id : null,
      properties: (item.properties && Object.keys(item.properties).length) ? item.properties : null
    });
    return commitQty(key, 0).then(function (cart) {  /* sin overlay blanco */
      /* FIX: toast de "removido" SOLO cuando era el último artículo del carrito.
         Para remociones normales el usuario ya ve que desapareció → no interrumpir. */
      if (cart && cart.item_count === 0) {
        var n = STATE.removedQueue.length;
        if (n === 1) showToast('"' + STATE.removedQueue[0].title + '" removido', true);
        else if (n > 1) showToast(n + ' productos removidos', true);
      }
      return cart;
    });
  }

  function addItem(id, qty, opts) {
    if (STATE.busy) return Promise.resolve();
    setBusy(true);
    vibrate(10);
    var line = { id: id, quantity: qty || 1 };
    if (opts && opts.selling_plan) line.selling_plan = opts.selling_plan;   /* preserva suscripción (undo) */
    if (opts && opts.properties) line.properties = opts.properties;
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [line] })
    }).then(function () {
      return refresh();
    }).then(function (cart) {
      broadcastCartUpdate();
      setBusy(false);
      return cart;
    }).catch(function (err) {
      console.warn('[EPIC] addItem failed', err);
      setBusy(false);
    });
  }

  /* ──────────────────────────────────────────────────────────────────
     7. UNDO TOAST
     ────────────────────────────────────────────────────────────────── */
  function showToast(text, withUndo) {
    var t = $('[data-ecd-toast]');
    var tx = $('[data-ecd-toast-tx]');
    var undoBtn = $('[data-ecd-undo]');
    if (!t || !tx) return;
    tx.textContent = text;
    if (undoBtn) undoBtn.style.display = withUndo ? '' : 'none';
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(STATE.undoTimer);
    STATE.undoTimer = setTimeout(hideToast, 5000);
  }
  function hideToast() {
    var t = $('[data-ecd-toast]');
    if (!t) return;
    t.classList.remove('is-visible');
    setTimeout(function () { t.hidden = true; }, 350);
    clearTimeout(STATE.undoTimer);
    STATE.removedQueue = [];                  /* al ocultarse el toast (5s o tras deshacer), expira el undo */
  }
  function performUndo() {
    var q = STATE.removedQueue;
    if (!q || !q.length) return hideToast();
    STATE.removedQueue = [];                 /* tomamos la cola y la vaciamos (evita doble-undo) */
    var lines = q.filter(function (r) { return r && r.id; }).map(function (r) {
      var l = { id: r.id, quantity: r.qty };
      if (r.selling_plan) l.selling_plan = r.selling_plan;   /* misma suscripción */
      if (r.properties) l.properties = r.properties;          /* mismas properties */
      return l;
    });
    if (!lines.length) return hideToast();
    setBusy(true);
    fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines })   /* restaura TODOS los removidos en UNA sola petición */
    }).then(function () { return refresh(); })
      .then(function () { broadcastCartUpdate(); setBusy(false); hideToast(); })
      .catch(function (err) { console.warn('[EPIC] undo failed', err); setBusy(false); hideToast(); });
  }

  /* loadUpsells + loadAddon REMOVIDOS 2026-05-27
     Reemplazados por el Smart Offer Engine (renderOffer/pickOffer/loadShaker).
     El carrusel "Complétalo con" no tenía comportamiento específico (mezclaba productos y protocolos);
     el Smart Offer siempre propone UNA capa que el popup de Kaching post-PDP no ofrece. */

  /* ──────────────────────────────────────────────────────────────────
     10. COUNTDOWN dispatch (cutoff 12 PM local)
     ────────────────────────────────────────────────────────────────── */
  function startCountdown() {
    stopCountdown();
    updateCountdown();
    STATE.countdownTimer = setInterval(updateCountdown, 60000);
  }
  function stopCountdown() {
    if (STATE.countdownTimer) clearInterval(STATE.countdownTimer);
    STATE.countdownTimer = null;
  }
  function updateCountdown() {
    /* Reescrito 2026-05-27: el strip de promise se unificó con la progress bar.
       Ahora el countdown se inyecta en el progress message cuando hay urgencia geo.
       Si no hay urgencia, dejamos el mensaje de "te faltan $X" estándar. */
    /* NOOP por ahora — el progress text ya muestra "Te faltan $X" o "Envío GRATIS desbloqueado".
       El countdown geo se mantiene EN OTRO LUGAR del sitio (PDP freeship bar). */
  }

  /* ──────────────────────────────────────────────────────────────────
     11. CONFETTI al desbloquear envío gratis (1 vez por sesión)
     ────────────────────────────────────────────────────────────────── */
  function triggerConfettiOnce() {
    try {
      if (sessionStorage.getItem('ecd_confetti') === '1') return;
      sessionStorage.setItem('ecd_confetti', '1');
    } catch (e) {}
    var panel = $('.ecd__panel');
    if (!panel) return;
    var wrap = document.createElement('div');
    wrap.className = 'ecd__confetti';
    var colors = ['#1A6BF5', '#16A34A', '#FFB020', '#5BA0FF', '#34C759'];
    var i, span;
    for (i = 0; i < 24; i++) {
      span = document.createElement('span');
      span.style.background = colors[i % colors.length];
      span.style.left = (Math.random() * 100) + '%';
      span.style.top = (Math.random() * 30) + '%';
      span.style.setProperty('--cx', ((Math.random() - 0.5) * 200) + 'px');
      span.style.animationDelay = (Math.random() * 0.3) + 's';
      wrap.appendChild(span);
    }
    panel.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 1700);
    vibrate(20);
  }

  /* ──────────────────────────────────────────────────────────────────
     12. INTERCEPT FETCH/XHR PARA SYNC con eventos del carrito
     · Auto-open del drawer en /cart/add.js (ATC desde PDP)
     · Refresh siempre (sync de la barra de envío)
     ────────────────────────────────────────────────────────────────── */
  var CART_RX = /\/cart\/(add|change|update|clear)(\.js)?/i;
  var CART_ADD_RX = /\/cart\/add(\.js)?/i;

  /* FIX audit #30 · rastreo del último gesto del usuario para distinguir un ATC real
     (clic/tap reciente) de un /cart/add en background de otra app (Klaviyo, etc.).
     Solo auto-abrimos el drawer si el cliente acaba de interactuar. */
  /* FIX: null en lugar de 0 — performance.now() reinicia a ~0 en cada carga de página,
     por lo que 0-0 < 2500 siempre devolvía true y el carrito se abría en cada navegación. */
  var _lastGestureAt = null;
  function markGesture() { _lastGestureAt = (window.performance && performance.now) ? performance.now() : +new Date(); }
  function userActedRecently() {
    if (_lastGestureAt === null) return false;
    var now = (window.performance && performance.now) ? performance.now() : +new Date();
    return (now - _lastGestureAt) < 1200; /* FIX hamburger: reducido de 2500ms; ATC real llega en <500ms */
  }
  function bindAjaxObserver() {
    /* FIX nav-flicker: no marcar gesto cuando el clic es en un <a href> de navegación
       o en botones de UI (hamburger, búsqueda, cuenta, menú drawer).
       Solo cuentan como "ATC intent" los clics sobre elementos de compra. */
    document.addEventListener('pointerdown', function(e) {
      /* Saltar links de navegación real */
      var a = e.target && e.target.closest('a[href]');
      if (a) {
        var h = (a.getAttribute('href') || '').trim();
        if (h && h.charAt(0) !== '#' && h.indexOf('javascript:') !== 0) return;
      }
      /* Saltar botones de menú/hamburger, búsqueda, cuenta, cierre de drawer */
      if (e.target && e.target.closest(
        '[aria-controls="menu-drawer"], [aria-controls*="menu"], ' +
        '.header__icon--menu, .header__icon--search, .header__icon--account, ' +
        '.menu-drawer__close-button, .menu-drawer__close, ' +
        '[class*="hamburger"], [data-drawer-close], ' +
        'details summary, .disclosure__button'
      )) return;
      markGesture();
    }, true);
    /* FIX flicker-en-PDP: solo Enter/Space activan markGesture con teclado.
       Teclas de navegación (flechas, etc.) no cuentan como "ATC intent".
       El submit event ya cubre keyboard-ATC en forms nativos. */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') markGesture();
    }, true);
    document.addEventListener('submit', markGesture, true);
    if (window.fetch && !window.fetch.__epicEcdWrapped) {
      var _f = window.fetch;
      window.fetch = function () {
        var url = '';
        try { url = (arguments[0] && arguments[0].url) ? arguments[0].url : ('' + arguments[0]); } catch (e) {}
        var pr = _f.apply(this, arguments);
        if (CART_RX.test(url)) {
          try {
            pr.then(function () {
              setTimeout(function () {
                refresh();
                broadcastCartUpdate();
                /* Auto-open en ATC para que EPIC Drawer SIEMPRE gane vs
                   cart-notification / cart-drawer nativos de Dawn.
                   FIX #30 · solo si el cliente acaba de interactuar (no en adds de background). */
                /* __epicNoDrawerUntil: permite que otros ATC (bestsellers, etc.) supriman la apertura automática */
                if (CART_ADD_RX.test(url) && userActedRecently() && !(window.__epicNoDrawerUntil && Date.now() < window.__epicNoDrawerUntil)) open();
              }, 150);
            });
          } catch (e) {}
        }
        return pr;
      };
      window.fetch.__epicEcdWrapped = true;
    }
    if (window.XMLHttpRequest && !window.XMLHttpRequest.prototype.__epicEcdWrapped) {
      var _open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try {
          if (CART_RX.test('' + url)) {
            var isAdd = CART_ADD_RX.test('' + url);
            this.addEventListener('load', function () {
              setTimeout(function () {
                refresh();
                broadcastCartUpdate();
                if (isAdd && userActedRecently() && !(window.__epicNoDrawerUntil && Date.now() < window.__epicNoDrawerUntil)) open(); /* FIX #30 */
              }, 150);
            });
          }
        } catch (e) {}
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__epicEcdWrapped = true;
    }
  }

  /* ──────────────────────────────────────────────────────────────────
     12b. SUPRIMIR CART NATIVO de Dawn (web components + pub/sub)
     · Sobrescribe cart-drawer.open() y cart-notification.open() con EPIC_CART_OPEN
     · Suscribe a PUB_SUB_EVENTS.cartUpdate de Dawn para sync con cualquier ATC
     · Ejecuta tras DOMContentLoaded para que customElements ya estén registrados
     ────────────────────────────────────────────────────────────────── */
  function suppressNativeCartUI() {
    /* Override de los custom elements nativos */
    var tryOverride = function () {
      ['cart-drawer', 'cart-notification', 'cart-drawer-items'].forEach(function (name) {
        try {
          var ctor = window.customElements && window.customElements.get(name);
          if (ctor && ctor.prototype && !ctor.prototype.__epicOverridden) {
            /* FIX: respetar el gate antes de delegar a open(). Así Kaching/apps
               externos que llaman cart-drawer.open() no saltan el gate de supresión. */
            ctor.prototype.open = function () {
              if (window.__epicNoDrawerUntil && Date.now() < window.__epicNoDrawerUntil) return;
              open();
            };
            ctor.prototype.renderContents = function () { /* no-op, EPIC renderiza */ };
            ctor.prototype.__epicOverridden = true;
          }
        } catch (e) { /* silent */ }
      });
    };
    tryOverride();
    /* Reintenta tras un tick (algunos themes registran custom elements tarde) */
    setTimeout(tryOverride, 800);
    setTimeout(tryOverride, 2000);

    /* Subscribirse al PUB_SUB de Dawn si existe (sync con otros agregados) */
    try {
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        if (window.PUB_SUB_EVENTS.cartUpdate) {
          window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
            refresh();
            /* FIX: solo auto-abrir si hubo gesto reciente Y no hay gate activo.
               __epicNoDrawerUntil lo setea bestsellers/homepage ATC para suprimir apertura. */
            if (userActedRecently() && !(window.__epicNoDrawerUntil && Date.now() < window.__epicNoDrawerUntil)) open();
          });
        }
      }
    } catch (e) { /* silent */ }

    /* Remover físicamente cart-notification del DOM (extra paranoia) */
    var killNative = function () {
      document.querySelectorAll('cart-notification, .cart-notification').forEach(function (n) {
        try { n.remove(); } catch (e) {}
      });
    };
    killNative();
    setTimeout(killNative, 1500);
  }

  function broadcastCartUpdate() {
    try {
      ['cart:update', 'cart:refresh', 'cart:change', 'epic:cart:updated'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { detail: STATE.cart }));
      });
    } catch (e) {}
  }

  /* ──────────────────────────────────────────────────────────────────
     13. EVENT BINDINGS (delegated)
     ────────────────────────────────────────────────────────────────── */
  function bindEvents() {
    /* Close clicks */
    ROOT.addEventListener('click', function (e) {
      var closeT = e.target.closest('[data-ecd-close]');
      if (closeT) { close(); return; }

      var rem = e.target.closest('[data-ecd-remove]');
      if (rem) {
        var key = rem.getAttribute('data-key');
        var item = ROOT.querySelector('[data-ecd-item][data-key="' + cssEscape(key) + '"]');
        collapseRow(item); /* colapso fluido inmediato (fade + scale + altura→0) */
        optimisticCount(key); /* baja YA el número del header/carrito flotante */
        setTimeout(function () { removeItem(key); }, 320);
        return;
      }

      var dec = e.target.closest('[data-ecd-qty-dec]');
      if (dec) {
        var qWrap = dec.closest('[data-ecd-qty]');
        var qN = qWrap.querySelector('[data-ecd-qty-n]');
        var curr = parseInt(qN.textContent, 10) || 1;
        var dkey = qWrap.getAttribute('data-key');
        if (curr - 1 <= 0) {
          /* bajar a 0 = remover (con animación + undo), por el flujo dedicado */
          var li0 = qWrap.closest('[data-ecd-item]');
          collapseRow(li0); /* colapso fluido inmediato */
          optimisticCount(dkey); /* baja YA el número del header/carrito flotante */
          setTimeout(function () { removeItem(dkey); }, 320);
        } else {
          setQtyOptimistic(dkey, curr - 1); /* instantáneo, sin overlay */
        }
        return;
      }
      var inc = e.target.closest('[data-ecd-qty-inc]');
      if (inc) {
        var qWrap2 = inc.closest('[data-ecd-qty]');
        var qN2 = qWrap2.querySelector('[data-ecd-qty-n]');
        var curr2 = parseInt(qN2.textContent, 10) || 1;
        vibrate(8);
        setQtyOptimistic(qWrap2.getAttribute('data-key'), curr2 + 1); /* instantáneo, sin overlay */
        return;
      }

      /* One-tap "súmale 1 → envío gratis" (barra de envío) */
      var topupBtn = e.target.closest('[data-ecd-bar-topup]');
      if (topupBtn) {
        var tkey = topupBtn.getAttribute('data-key');
        if (tkey) {
          var tcur = 0;
          ((STATE.cart && STATE.cart.items) || []).forEach(function (it) { if (it.key === tkey) tcur = it.quantity; });
          vibrate(10);
          topupBtn.hidden = true; /* desaparece al instante; renderShippingBar lo recalcula al commit */
          setQtyOptimistic(tkey, tcur + 1);
        }
        return;
      }

      /* Shipping protection toggle · Route App pattern */
      var protectInput = e.target.closest('[data-ecd-protect-input]');
      if (protectInput) {
        try {
          /* Si el cliente apaga manualmente, NO re-auto-agregamos en esta sesión */
          if (!protectInput.checked) sessionStorage.setItem('ecd_protect_optout', '1');
          else sessionStorage.removeItem('ecd_protect_optout');
        } catch (e) {}
        toggleProtection(protectInput.checked);
        return;
      }

      var checkoutBtn = e.target.closest('[data-ecd-checkout]');
      if (checkoutBtn) {
        vibrate(15);
        /* Si el carrito tiene Shaker, cadenamos el código SHAKERBB129 para que
           Shopify aplique el descuento al checkout (mismo patrón que bundle/hotsale).
           Sin esto, el cliente vería el Shaker a precio lista ($299) y NO los $129 prometidos. */
        var url = '/checkout';
        if (STATE.cart && STATE.cart.items.some(function (it) { return /shaker/i.test(it.product_title || ''); })) {
          url = '/discount/' + encodeURIComponent(SHAKER_DISCOUNT_CODE) + '?redirect=/checkout';
        }
        /* IMPERATIVO: asegura que la nota de regalos esté escrita ANTES de ir al checkout.
           Si nada cambió, updateGiftNote resuelve al instante (sin demora). */
        updateGiftNote(STATE.cart).then(function () { window.location.href = url; });
        return;
      }

      var undoBtn = e.target.closest('[data-ecd-undo]');
      if (undoBtn) { performUndo(); return; }

      /* Smart Offer button (único upsell adaptativo) */
      var offerBtn = e.target.closest('[data-ecd-offer-btn]');
      if (offerBtn) {
        e.preventDefault();
        var action = offerBtn.getAttribute('data-action') || '';
        var href = offerBtn.getAttribute('data-href') || '';
        if (action === 'add-shaker') {
          var doAdd = function () {
            if (!STATE.shakerVariantId) return;
            offerBtn.classList.add('is-added');
            var txEl = offerBtn.querySelector('[data-ecd-offer-btn-tx]');
            if (txEl) txEl.textContent = '✓ Agregado';
            addItem(STATE.shakerVariantId, 1);
          };
          if (STATE.shakerVariantId) {
            doAdd();
          } else {
            /* lazy-load la primera vez y luego agrega */
            loadShaker().then(doAdd);
          }
        } else if (action === 'add-crosssell' && STATE.crossSell && STATE.crossSell.variant_id) {
          offerBtn.classList.add('is-added');
          var txC = offerBtn.querySelector('[data-ecd-offer-btn-tx]');
          if (txC) txC.textContent = '✓ Agregado';
          addItem(STATE.crossSell.variant_id, 1);   /* /cart/add.js → add_to_cart nativo (todas las plataformas) */
        } else if (action === 'subscribe-first' && STATE.cart && STATE.cart.items.length) {
          /* Convertir TODOS los items elegibles a suscripción in-place sin redirect */
          var txEl = offerBtn.querySelector('[data-ecd-offer-btn-tx]');
          if (txEl) txEl.textContent = 'Activando…';
          offerBtn.disabled = true;
          subscribeAllItems().then(function (ok) {
            offerBtn.disabled = false;
            if (ok > 0) {
              offerBtn.classList.add('is-added');
              if (txEl) txEl.textContent = '✓ Activado';
            } else if (txEl) {
              txEl.textContent = 'No disponible';
            }
          });
        } else if (href) {
          window.location.href = href;
          close();
        }
        return;
      }
    });

    /* Escape para cerrar */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ROOT.classList.contains('is-open')) close();
    });

    /* Re-paint si cart-icon-bubble cambia (otros scripts agregan algo) */
    var ccb = document.querySelector('#cart-icon-bubble');
    if (ccb && window.MutationObserver) {
      new MutationObserver(function () {
        if (ROOT.classList.contains('is-open')) refresh();
      }).observe(ccb, { childList: true, subtree: true, characterData: true });
    }

    /* Eventos externos */
    ['cart:added', 'cart:refresh'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (ROOT.classList.contains('is-open')) refresh();
      });
    });

    /* Geo promise listo: actualizar countdown */
    document.addEventListener('epic:geo:ready', function () {
      if (ROOT.classList.contains('is-open')) updateCountdown();
    });
  }

  /* ──────────────────────────────────────────────────────────────────
     14. HELPERS
     ────────────────────────────────────────────────────────────────── */
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function img2x(url, w) {
    if (!url) return '';
    try {
      var u = url.replace(/(_(pico|icon|thumb|small|compact|medium|large|grande|original|master)+)?(\.(?:jpg|jpeg|png|webp|avif|gif))/i, '_' + (w || 200) + 'x$3');
      if (u === url) {
        if (url.indexOf('?') === -1) return url + '?width=' + (w || 200);
        return url + '&width=' + (w || 200);
      }
      return u;
    } catch (e) { return url; }
  }
  function cssEscape(s) {
    try { if (window.CSS && CSS.escape) return CSS.escape(s); } catch (e) {}
    return ('' + s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  /* ──────────────────────────────────────────────────────────────────
     15. BOOT
     ────────────────────────────────────────────────────────────────── */
  function boot() {
    bindCartIcon();
    bindAjaxObserver();
    bindEvents();
    suppressNativeCartUI();
    /* ANTI-FOUC · renderiza en el BOOT con el drawer CERRADO (invisible). Así, cuando el
       cliente lo abre, ya está en su estado FINAL (precios con descuento, totales netos,
       oferta, regalos) — nada cambia de color ni "carga al último momento" al abrir.
       Pedido del usuario: "abrir el carrito y verlo como ya debería estar". */
    fetchJSON('/cart.js').then(function (cart) {
      STATE.cart = cart;
      STATE.hasRendered = true;
      try { render(cart); } catch (e) { /* no romper el boot si algo falla */ }
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
